import dayjs from "dayjs";
import { renderAlert } from "../../../CommonComponents/Alert/Alert";
import { updateValues } from "./dataHarvestHelper";
import { v4 as uuidv4 } from 'uuid';
import { SetTimeSeriesColumnProperties,calculateDayDifference, checkIfSelectedColumnsCanBeGrouped, countWeekdays, getCellClass, getCellStyle,  getParentMDVValueAsRollUp, makeFirstColumnAlwaysVisibleUnderAGroup, processDuration, returnEndDateIfStartIsChanged, getUniqueChildrenArray, makeColStateObj } from "./helperFunctions";
import { findAvailableSlotsForColumnNumbering } from "./callbackHelper";
import { HRMSTimeSeriesChildColumnListData, timeSeriesChildColumnListData, TotalColumnTimeSeriesListData } from "../cellComponents/FushionColumn/constants/MdvConstant";
import { isStringifiedArrayWithPropName, isTheGroupTimeseries } from "../../../helpers/ExportHelper"; 
import { processDate } from "./dateHelper";
import { getTotalColumn, processDateRollupsAndSuccessorNodes } from "./cellValueChangeHelpers";
import { checkIfRollupEnabledInMDV, findAllRollupColumns,updateCellValue } from "./xTablesHelper";
import xTablesStore from "../redux/xTablesStore";
import store from "../../../redux/store";

export const checkForCircularDependency = (eleId, predecessorId, row, params, visitedNodes = new Set(), hasCommaSeparatedPredecessors = false,rootNodeParents) => {
    console.log("Checking for circular dependency", eleId, predecessorId, row, params.node?.rowIndex, visitedNodes)
    // hasCommaSeparatedPredecessors is used to check whether the predecessor node has comma-separated values.
    let deepCopyPredeccessorVisitedNode = hasCommaSeparatedPredecessors ? new Set([...visitedNodes].map(item => JSON.parse(JSON.stringify(item)))) : visitedNodes;
    // Base case: if we reach the root node, there's no circular dependency
    if (eleId === "ROOT_NODE_ID") {
        return false;
    }
    // No predecessor, no circular dependency
    if (!predecessorId) {
        return false;
    }
    // Circular dependency found if the current element is the same as the predecessor
    if (eleId === predecessorId) {
        return true;
    }
    // Check if this predecessor node was already visited
    if (deepCopyPredeccessorVisitedNode.has(predecessorId)) {
        return true; // Circular dependency detected
    }
    // Mark the current predecessor as visited
    deepCopyPredeccessorVisitedNode.add(predecessorId);
    // Get the predecessor node
    const predecessorNode = params.api.getRowNode(predecessorId);
    // Check if the predecessor node exists and handle comma-separated predecessor nodes
    if (predecessorNode?.data?.predecessorNodes) {
    const predecessorNodeIds = predecessorNode.data.predecessorNodes.split(',').map(id => id.trim());
    let hasCommaSeparatedPredecessors = predecessorNodeIds.length > 1 ? true : false
    // Check for circular dependencies in each predecessor node
    for (const predecessorNodeId of predecessorNodeIds) {
        if (deepCopyPredeccessorVisitedNode && !deepCopyPredeccessorVisitedNode.has(predecessorNodeId)){
            if (checkForCircularDependency(eleId, predecessorNodeId, predecessorNode, params, deepCopyPredeccessorVisitedNode, hasCommaSeparatedPredecessors)) {
                return true; // Circular dependency found
            }
        }
        else if(deepCopyPredeccessorVisitedNode.has(predecessorNodeId)){
            return true
        }  
    }
}

     // Now check all leaf children of the current row for circular dependency
    let childPredecessorNodeArray = [];
    const childrenArray = getUniqueChildrenArray(predecessorNode);

    let isFirstIterationOfecursiveFunction = (deepCopyPredeccessorVisitedNode.size - rootNodeParents?.size || 0) === 1
    // Ensure we only run this once when visitedNodes is empty (just started)
    if (childrenArray.length > 1) {
        for (const [index, child] of childrenArray.entries()) {
            if (child.data.l_id.includes(predecessorNode.id)) {
                if (index > 0 && child.id === eleId) {
                    return true;  // Stop checking further children once a match is found
                }
                if (index > 0 && child?.data?.predecessorNodes) {  // Ignore the first child
                    // Collect predecessor IDs from all leaf children
                    const predecessorIdArray = child.data.predecessorNodes.split(',').map(id => id.trim());
                    childPredecessorNodeArray = [...childPredecessorNodeArray, ...predecessorIdArray];
                }
            }
        }
        // Recursively check for circular dependencies in the children
        for (const childPredecessorId of childPredecessorNodeArray) {
            if (deepCopyPredeccessorVisitedNode && !deepCopyPredeccessorVisitedNode.has(childPredecessorId)) {
                if (checkForCircularDependency(eleId, childPredecessorId, row, params, deepCopyPredeccessorVisitedNode, true)) {
                    return true;  // Circular dependency found in leaf children
                }
            }
            else if (deepCopyPredeccessorVisitedNode.has(childPredecessorId)) {
                return true
            } 
         }
     }
    // Check if the current row's parent node is involved in the circular dependency
    if (row.parent.id === "ROOT_NODE_ID") {
        return false
    }
    const parentNode = params.api.getRowNode(row.parent.id);
    if (parentNode?.id === "ROOT_NODE_ID") {
        return false; // Reached the root, no circular dependency
    }
    // If the parent node itself is the predecessor, circular dependency exists
    if (parentNode?.id === predecessorId) {
        return true;
    }
    // Validate that the parent's successor nodes do not include this predecessor
    if (parentNode?.data?.successorNodes?.includes(predecessorId)) {
        return true; // Circular dependency via the parent node's successors
    }
    return false
}; 
 

export const getNodesArrayFromIndex=(valString,params,row,startDate ,endDate)=>{
    if(!valString) return '';
    let valArray=valString.split(",");
    let nodeArrayInString=''
    let processedIds = new Set(); // Set to track processed predecessor IDs
    let rows = params.api.getModel().rootNode.allLeafChildren;
    valArray.forEach(element => { 
        if (element.trim().match(/^\d+(\s*\+\s*\d+[dDwWhH])?$/)) {
            let trimmedElement = element.trim();
            let parts = trimmedElement.split('+');
            let rowIndex = parseInt(parts[0]);
            let duration = parts[1] ? parts[1].trim() : ''; // Extract duration part if present
            let eleId = rows[rowIndex - 1];
            if(eleId===undefined){
                renderAlert('Invalid Predecessor value','error')    
                return false;
            }
           
            if(eleId.data?.checkinagent){
            renderAlert(`Could not assign the HRMS check-in information rows as the predecessor value`, 'error');
                return false;
            }
            // if(eleId &&((eleId.data[startDate] === ""||eleId.data[startDate] ===null||eleId.data[startDate] ===undefined )||(eleId.data[endDate] ===""||eleId.data[endDate] ===null||eleId.data[endDate] ===undefined)||(! eleId?.data?.primaryCol||eleId?.data?.primaryCol===''||eleId?.data?.primaryCol===null||eleId?.data?.primaryCol===undefined))){
            //     renderAlert('Invalid Predecessor val const CheckinAgentRow = params?.node?.data?.checkinagent ue','error')    
            //     return false;
            // }
            let parentNodes = getAllParentsOfANode(row)
            let allParentNodesMarkedAsVisited= new Set(Array.from(parentNodes).map(row => row.id))
            const deepCopiedSet = new Set(Array.from(allParentNodesMarkedAsVisited, item => structuredClone(item)));
            let isCircularDependency=checkForCircularDependency(row.id,eleId?.id,row, params,allParentNodesMarkedAsVisited,false,deepCopiedSet)
            if(isCircularDependency){
                renderAlert('Circular dependency','error')
                return false;
            }
            // if (params.node.allChildrenCount > 0) {
            //     renderAlert('Cannot accept children as predecessor', 'error');
            //     return false;
            // }
            if (params.node.childrenAfterGroup && params.node.childrenAfterGroup.some(child => child.id === eleId)) {
                renderAlert('Cannot accept children as predecessor', 'error');
                return false;
            }
        
            let currentNode = params.node;
            while (currentNode.parent) {
                if (currentNode.parent.id === eleId) {
                    renderAlert('Cannot accept parents or ancestors as predecessor', 'error');
                    return false;
                }
                currentNode = currentNode.parent;
            }
             if (processedIds.has(eleId.id)) {
                renderAlert('Duplicate predecessor value', 'error');
                return false;
            }
            if(eleId && eleId.id) {
                if(nodeArrayInString.length > 0) nodeArrayInString+=","
                nodeArrayInString+=eleId.id + (duration ? '+' + duration : '');
                processedIds.add(eleId.id);
            }
        }
        
    });
    return nodeArrayInString;

}
export const getAllParentsOfANode = (node,visitedNodes = new Set())=>{
    if(node.parent.id === "ROOT_NODE_ID") return visitedNodes
    visitedNodes.add(node.parent)
    return getAllParentsOfANode(node.parent, visitedNodes)
}

export const getIndexesFromNodeArray = (nodeArrayInString, params, numberOfCheckInRows)=>{
    if(!nodeArrayInString || nodeArrayInString ==='' || typeof nodeArrayInString !== 'string') return '';
    let valArray=nodeArrayInString.split(",");
    let indexString=''
    let primaryColValue=''
    let rows = params.api.getModel().rootNode.allLeafChildren;
    valArray.forEach(element => {
        if(element){
            let parts = element.trim().split('+');
            let rowId = parts[0]
            let duration = parts[1] ? parts[1].trim() : '';
            let eleId = params.api.getRowNode(rowId);
            if(eleId && eleId.id) {
                if (indexString.length > 0) {
                    indexString += ","
                    primaryColValue += ","
                }        
                indexString+=numberOfCheckInRows ? ((eleId.sourceRowIndex + 1 - numberOfCheckInRows) + (duration ? '+' + duration : '')) : ((eleId.sourceRowIndex + 1 ) + (duration ? '+' + duration : '')) 
                primaryColValue+='primaryCol' in eleId?.data &&eleId?.data["primaryCol"] !== undefined && eleId?.data["primaryCol"] !== null? eleId?.data["primaryCol"]:''
            }
        }
    })   
    return {indexString,primaryColValue};     
} 
export const getNodeListFromIdList = (idList, gridRef) => {
    if (!idList || idList.length === 0) {
        return [];
    }

    return idList.map(function (idString) {
        // Split the string into row ID and duration
        var parts = idString.split('+');
        var nodeId = parts[0].trim(); // Extract row ID

        if (!nodeId) {
            // renderAlert('Invalid predecessor format: ' + idString, 'error');
            return null;
        }
        var node = gridRef.current.api.getRowNode(nodeId);
        if (!node) {
            //  renderAlert('Invalid row ID: ' + nodeId, 'error');
            return null;
        }

        var duration = parts.length > 1 ? parts[1].trim() : ''; // Extract duration if present

        return { node: node, duration: duration };
    }).filter(function (item) {
        return item !== null;
    });
};

function addEleToStringWithCommaAsDelimeter(nodeArrayInString,newEle){
    if (!newEle) return nodeArrayInString
    let finalString = nodeArrayInString
    if (!nodeArrayInString || nodeArrayInString.trim() === '') finalString = newEle
    else {
        let nodeArray = nodeArrayInString.split(',').filter(item => item.trim() !== '');

        // If newEle is not in the array, append it
        if (!nodeArray.includes(newEle)) {
          finalString = nodeArray.concat(newEle).join(',');}
    }
    return finalString
}
export const removeEleFromStringWithCommaAsDelimiter=(nodeArrayInString, removeEle)=> {
    if (!nodeArrayInString) return nodeArrayInString;
    if (!removeEle) return nodeArrayInString;

    // Split the string into an array
    let array = nodeArrayInString.split(',').map(item => item.trim());

    // Filter out the element to be removed
    array = array.filter(item => item !== removeEle);

    // Join the array back into a comma-separated string
    return array.join(',');
}
export const addThisNodeAsSuccessorToOtherRows=(predecessorString,params,successorNode,rowObj)=>{
    if(!predecessorString) return [];
    let valArray=predecessorString.split(",");
    let nodesWithSuccessorUpdated=[],undoRowsSuccessor=[]
    valArray.forEach(element => {
            let eleId
            if(rowObj && rowObj[element]){
                eleId ={id:element,data: rowObj[element]}
            }
            else eleId = params.api.getRowNode(element)
            if(eleId && eleId.id) {
                let data=eleId.data
                if(data) {
                    undoRowsSuccessor.push(JSON.parse(JSON.stringify(data)))
                    data['successorNodes']=addEleToStringWithCommaAsDelimeter(data['successorNodes'],successorNode)
                    nodesWithSuccessorUpdated.push(data)
                }
            }
    })
    return {nodesWithSuccessorUpdated,undoRowsSuccessor}
}
export const removeThisNodeAsSuccessorFromOtherRows = (predecessorNodes, params, successorNode, undoRowsSuccessor, rowObj, updatedRows) => {
    if (typeof predecessorNodes === 'string') predecessorNodes = predecessorNodes.split(',')
    if (predecessorNodes.length == 0) return []
    let nodesWithSuccessorUpdated = []
    if (undoRowsSuccessor === undefined) {
        undoRowsSuccessor = [];
    }

    predecessorNodes.forEach((element) => {
        let eleId
        // Check if updatedRows contains the element
        const updatedRow = updatedRows?.find(row => row.id === element);
        if (rowObj && rowObj[element]) {
            eleId = { id: element, data: rowObj[element] }
        }
        else if (updatedRow) {
            eleId = { id: element, data: updatedRow };
        }
        else eleId = params.api.getRowNode(element)
        if (eleId && eleId.id) {
            let data = eleId.data
            if (data) {
                if (!undoRowsSuccessor?.some(prevRow => prevRow.id === data.id)) {
                    undoRowsSuccessor.push(JSON.parse(JSON.stringify(data)))
                }
                data['successorNodes'] = removeEleFromStringWithCommaAsDelimiter(data['successorNodes'], successorNode)
                nodesWithSuccessorUpdated.push(data)
                if (data?.id && rowObj)
                    rowObj[data.id] = data
            }
        }
    })
    return { nodesWithSuccessorUpdated, undoRowsSuccessor }
}
export const removeThisNodeAsPredecessorFromOtherRows=(sucessorNodes,params,predecessorNode,undoRowsPredecessor,rowObj,predeccessorColumnField)=>{
    if(typeof sucessorNodes === 'string' ) sucessorNodes = sucessorNodes.split(',')
    if(sucessorNodes.length==0) return []
    let nodesWithPredecessorUpdated=[]
    if (undoRowsPredecessor === undefined) {
        undoRowsPredecessor = [];
    }

    sucessorNodes.forEach((element)=>{
        let eleId
        if(rowObj && rowObj[element]) {
            eleId ={id:element,data: rowObj[element]}
        }
        else eleId = params.api.getRowNode(element)
        if(eleId && eleId.id) {
            let data=eleId.data
            if(data) {
                undoRowsPredecessor.push(JSON.parse(JSON.stringify(data)))
                data['predecessorNodes']=removeEleFromStringWithCommaAsDelimiter(data['predecessorNodes'],predecessorNode)
                data[predeccessorColumnField] = data['predecessorNodes']
                data[predeccessorColumnField + '_es'] = updateCellValue(data,predeccessorColumnField + '_es',"value",data['predecessorNodes'],'')
                nodesWithPredecessorUpdated.push(data);
                rowObj[data.id] = data
            }
        }
    })
    return {nodesWithPredecessorUpdated,undoRowsPredecessor}
}
export const getMinValueFromPredecessor=(currValue,predecessorRows,endDateCol,params,predecessorCol,valueChangeByOnCellValueChange) => { 
    let predecessorRowsArray=predecessorRows?.split(',')
    let predecessorCellValue
    predecessorRowsArray?.forEach((rowWithDuration)=>{
       let [row, durationPart] = rowWithDuration.split('+');
        let rowData=params.api.getRowNode(row)
        predecessorCellValue = rowWithDuration
        if (rowData && rowData.data && rowData.data[endDateCol]) {    
            let startDate = rowData.data[endDateCol]
            if ((currValue === null || currValue === undefined || currValue === 'Invalid Date') && !new Date(startDate) < new Date(currValue))
                currValue = startDate
            else if (new Date(startDate) < new Date(currValue)) {
                let duration = countWeekdays(startDate, currValue) - 2;
                const incrementedStartDate = increaseDateByOne(startDate,`${row}+${duration}d`);
                var formattedDate = moveStartDateToMonday(dayjs(incrementedStartDate).format('MM/DD/YYYY'))
                console.log("currValue: " + currValue,"startDate",startDate,"incrementedStartDate",incrementedStartDate,"formattedDate",formattedDate,"rowIndex",params.node.rowIndex)
                if (duration > 0 && params.colDef.field != endDateCol ) {
                    predecessorCellValue = `${row}+${duration}d`;
                    currValue = formattedDate
                }
             else  if (new Date(formattedDate).getTime() === new Date(currValue).getTime()) {
                predecessorCellValue = `${row}`;
                currValue = currValue;
            }
                else {
                    predecessorCellValue = rowWithDuration
                    currValue = formattedDate
                }
            }
            else if (new Date(startDate) >= new Date(currValue)) {
                if(valueChangeByOnCellValueChange) 
                renderAlert(
                    "Start Date cannot be earlier than the End Date of the linked predecessor row.",
                    "info"
                );
                currValue=startDate
                currValue=increaseDateByOne(currValue,rowWithDuration)
                predecessorCellValue = `${rowWithDuration}`;
            }
            console.log("currValue: " + currValue,"startDate",startDate,"rowIndex",params.node.rowIndex)

        }
    })
   
    return {minValue:currValue, predecessorCellValue};
}
function minDate(date1, date2) {
    // Convert both inputs to Date objects if they aren't already
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    
    // Compare the two dates and return the earlier one
    return d1 < d2 ? date1 : date2;
  }
  export function maxDate(date1, date2) {
    // Convert both inputs to Date objects if they aren't already
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    
    // Compare the two dates and return the earlier one
    return d1 < d2 ? date2 : date1;
  }
  function getMaxDuration(validatedPredecessorValue) {
    var durationMatches = validatedPredecessorValue?.split(',').map(function (item) {
        var match = item.trim().match(/\+\s*(\d+)([dDwWhH])/);
        if (match) {
            var value = parseInt(match[1]);
            var unit = match[2].toLowerCase();
            return { value, unit };
        }
        return null;
    }).filter(Boolean);

    var maxDuration = 0;
    durationMatches?.forEach(function (duration) {
        var days = 0;
        switch (duration.unit) {
            case 'd':
                case 'D':
                days = duration.value;
                break;
            case 'w':
                case 'W':
                days = duration.value * 5; // Convert weeks to weekdays (assuming 5 days per week)
                break;
            case 'h':
            case 'H':
                days = duration.value / 24; // Convert hours to days
                break;
        }
        if (days > maxDuration) {
            maxDuration = days;
        }
    });
    return maxDuration;
}

function isWeekend(date) {
    return date.getDay() === 0 || date.getDay() === 6; // 0 is Sunday, 6 is Saturday
}

export function increaseDateByOne(date, value) {
    // Ensure the input is converted to a Date object
    var initialDate = new Date(date);
    // Check if the conversion was successful
    if (isNaN(initialDate.getTime())) {
        renderAlert('Invalid date input','error')
        throw new Error("Invalid date input");
    }
    let maxDuration= value!=null&& value!=''&&value!=undefined?getMaxDuration(value)+1:1
    var daysToAdd = 1;
    while (daysToAdd < maxDuration+1) {
        initialDate.setDate(initialDate.getDate() + 1);
        if (!isWeekend(initialDate)) {
            daysToAdd++;
        }
    }

    // Format the new date using dayjs
    var formattedDate = dayjs(initialDate).format('MM/DD/YYYY');
    return moveStartDateToMonday(formattedDate);
};

export const getStartDateForSuccessors = (newValue, successorNodes, startDateCol, colDef, predecessorCol, endDateCol, originalRow, predecessorEndDateCol, isPredecessorColumnEdit, isDurationColumnEdit, gridRef, updatedRows, originalFirstRow,loggedInUser) => {
    let successorNodesArray = successorNodes.split(','), rowsToBeChanged = [], undoRows = []
    successorNodesArray.forEach((row) => {
        let rowData = gridRef.current.api.getRowNode(row)
        if (rowData && rowData.data) {
            undoRows.push(JSON.parse(JSON.stringify(rowData.data)))
            const predecessors = rowData.data?.predecessorNodes?.split(',') || [];
            if (predecessors.includes(originalRow.id)) {
                let rowsToProcess = getNodeListFromIdList(rowData?.data[predecessorCol] === '' ? [] : rowData?.data[predecessorCol]?.split(','), gridRef)
                if (rowsToProcess.length) {
                    let endDates = rowsToProcess.map(item => {
                        let updateRowData;

                        // Check if `originalRow.id === item.node.id`
                        if (originalRow.id === item.node.id) {
                            updateRowData = originalRow; // Use the original row data
                        }
                        else if (originalFirstRow && originalFirstRow.id === item.node.id) {
                            updateRowData = originalFirstRow;

                        } else {
                            // Check if the row is present in updatedRows
                            const updatedRow = updatedRows.find(row => row.id === item.node.id);
                            updateRowData = updatedRow ? updatedRow : item.node.data; // Use updated row data if available, else use node data
                        }
                        let date = new Date(updateRowData[endDateCol + '_es']?.value);

                        return isNaN(date.getTime())
                            ? ''
                            : new Date(increaseDateByOne(date, `${item.node.id}+${item.duration}`));
                    });

                    let formattedDate, increasedValue
                    if (endDates.includes(null) || endDates.includes('') || endDates.includes(undefined) || !endDates.length) {
                        formattedDate = '';
                    }
                    else {
                        // Calculate the maximum end date
                        const maxDate = new Date(Math.max(...endDates.map(date => new Date(date).getTime())));
                        formattedDate = dayjs(maxDate).format('MM/DD/YYYY');
                        // increasedValue = newValue
                    }

                    let newStartDate
                    newStartDate = formattedDate;
                    rowData.data[startDateCol] = newStartDate
                    rowData.data[startDateCol + '_es'] = updateCellValue(rowData.data,startDateCol + '_es',"value",newStartDate,loggedInUser)
                    // if (rowData.data[startDateCol + '_es']) rowData.data[startDateCol + '_es'].value = newStartDate
                    // else rowData.data[startDateCol + '_es'] = {
                    //     value: newStartDate,
                    //     "attachments": [],
                    //     notes: "",
                    //     format: '',
                    //     cellStyle: {}
                    // }
                    rowsToBeChanged.push(rowData.data)
                }
            }
        }
    })
    return { changedSuccessorRows: rowsToBeChanged, undoRows };
}
export function updateOrCreateObject(obj, field, newValue) {
    if (obj && typeof obj === "object") {
      // If the object exists, update the field with the new value
      obj[field] = newValue;
    } else {
      // If the object doesn't exist, create a new object with the field and new value
      obj = { [field]: newValue };
    }
    return obj;
  }
  export function moveStartDateToMonday(date) {
    let dateObj = new Date(date);
    let day = dateObj.getDay();

    if (day === 0) {
        // If Sunday, move to next Monday
        dateObj.setDate(dateObj.getDate() + 1);
    } else if (day === 6) {
        // If Saturday, move to next Monday
        dateObj.setDate(dateObj.getDate() + 2);
    }
    // If it's any other day, the date remains unchanged

    return dayjs(dateObj).format('MM/DD/YYYY');
}

export function checkAndUpDateValueAccordingToColumnType(column,value,row){
    if(column.type==='predecessor'){
        if(row.predecessorNodes) {
            value=row[column.field+'_es']? row[column.field+'_es'].value:row.predecessorNodes
        }
    }
    return value;
}
function isDateFormatYYYYMMDD(dateString) {
    const regex = /^\d{2}-\d{2}-\d{4}$/;
    return regex.test(dateString);
}
export function getAllTimeSeriesCellsForARow(obj,startDate,endDate){
    const dateValues = [];

    // Iterate through object fields
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            // Check if the value matches the "YYYY-MM-DD" format
            const dateValue = obj[key];
            if (isDateFormatYYYYMMDD(key)) {
                let datekey= new Date(key)
                const normalizeDate = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());
                // Check if dateValue is between startDate and endDate
                if (normalizeDate(datekey) >= normalizeDate(startDate) && datekey <= endDate) {
                    dateValues.push(dateValue);
                }
            }
        }
    }
    return dateValues;
}

export const checkForDuplicates = (array) => {
    const seenPropNames = new Set();
    const seenPropAbbreviations = new Set();
    const duplicates = {
      propNames: new Set(),
      propAbbrevation: new Set(),
    };
   
    array.forEach((item) => {
      if (seenPropNames.has(item.propName)) {
        duplicates.propNames.add(item.propName);
      } else {
        seenPropNames.add(item.propName);
      }
   
      if (seenPropAbbreviations.has(item.propAbbrevation)) {
        duplicates.propAbbrevation.add(item.propAbbrevation);
      } else {
        seenPropAbbreviations.add(item.propAbbrevation);
      }
    });
   
    return duplicates;
  };

export const areSiblings=(predecessorValues,params)=>{
    let parentNode = params.node.parent;
    let allChildrenOfParent = parentNode?.childrenAfterAggFilter
    let siblings = allChildrenOfParent.filter(item => item.data.id !== params.data?.id && params.data?.l_id?.split(".").length === params.data?.l_id?.split(".").length).map(item => item.data.id)
    let areSiblings= false
    if (siblings.includes(predecessorValues?.data?.id)) {
        areSiblings= true
    }
        return areSiblings
}
export function  updatedPredecessorCellValue(params, row,column){
    let {predecessorStartDate, predecessorEndDate} = params?.colDef?.linkedColumns || {};
    let newValue
    let validatedPredecessorValue
    const regex = /^(\d+(\s*\+\s*\d+[dDwWhH])?(\s*,\s*\d+(\s*\+\s*\d+[dDwWhH])?)*)$/;
    // Check if the newValue matches the regex pattern
    if (regex.test(params.newValue)) {
        // Get the nodes array from the cleaned value
        newValue =  getNodesArrayFromIndex(params.newValue||'',params,params.node,predecessorStartDate ,predecessorEndDate)
        validatedPredecessorValue = newValue
    } 
    else if(params.newValue!==undefined && params.newValue!=null && params.newValue!=''){
         renderAlert('Invalid predecessor format' , 'error');
         validatedPredecessorValue=newValue
    
    }
   
    return validatedPredecessorValue
}

function isValidPredecessor(params, row, eleId) {  
    if (params.node.allChildrenCount > 0) {
        return false;
    }
    let isCircularDependency = checkForCircularDependency(row.id, eleId, params.node, params);
    if (isCircularDependency) {
        if(params.node.rowIndex !== null) renderAlert('Circular dependency','error')
        return false;
    }
    if (params.node.childrenAfterGroup && params.node.childrenAfterGroup.some(child => child.id === eleId)) {
        return false;
    }
    let currentNode = params.node;
    while (currentNode.parent) {
        if (currentNode.parent.id === eleId) {
            return false;
        }
        currentNode = currentNode.parent;
    }
    return true;
}

function removeInvalidPredecessor(row, eleId, params, duration) {
    let rowsToUpdate = [];
    let newValue= duration?`${eleId}+ ${duration}`:`${eleId}`;
    let newPredecessorValue = removeEleFromStringWithCommaAsDelimiter(row[params.colDef.field], newValue);
    row[params.colDef.field] = newPredecessorValue 
    row[params.colDef.field + "_es"] = updateOrCreateObject(row[params.colDef.field + "_es"], "value", newPredecessorValue);
    row['predecessorNodes'] = removeEleFromStringWithCommaAsDelimiter(row['predecessorNodes'], eleId); 
    rowsToUpdate = [row];
    let predecessorNode = params.api.getRowNode(eleId);
    if (predecessorNode && predecessorNode.data) {
        let newSuccessorValueForPredecessorRow = removeEleFromStringWithCommaAsDelimiter(predecessorNode.data['successorNodes'], params.data.id);
        predecessorNode.data['successorNodes'] = newSuccessorValueForPredecessorRow;
        rowsToUpdate.push(predecessorNode.data);
        params.api.applyTransactionAsync({
            update: rowsToUpdate,
        });
    }
}

export function correctPredecessorValue(params, row, column) {
    if (!params?.node?.data?.hasOwnProperty(params.colDef.field) || !params?.node.data[params.colDef.field]) {
        return '';
    }
    let valArray = params?.node.data[params.colDef.field].split(",");
    let nodeArrayInString = '';
    let rowsToUpdate = [];
    let newPredecessorValue;

    valArray.forEach(element => {
        let trimmedElement = element.trim();
        let parts = trimmedElement.split('+');
        let eleId = parts[0];
        let duration = parts[1] ? parts[1].trim() : ''; // Extract duration part if present

        if (isValidPredecessor(params, row, eleId)) {
            if (nodeArrayInString.length > 0) nodeArrayInString += ",";
            nodeArrayInString += eleId + (duration ? '+' + duration : '');
        } else {
            newPredecessorValue = removeInvalidPredecessor(row, eleId, params, duration);
        }

    })
    return nodeArrayInString
}
export function removeDurationFromValue(value) {
    if (!value) return '';
    let valuesArray = value.split(',');
    let cleanedValues = valuesArray.map(v => v.split('+')[0].trim());
    return cleanedValues.join(',');
}

export function convertToMinutes(value) {
    const hours = Math.floor(value); // Extract hours
    const fractionalPart = value - hours; // Get the fractional part
    // Convert fractional part to string to check its length
    const fractionalPartStr = value?.toString().split('.')[1] || '00'; // Get the fractional part as a string
    // Pad the fractional part to ensure it's at least two digits
    const paddedFractionalPartStr = fractionalPartStr.length === 1 ? fractionalPartStr : fractionalPartStr.substring(0, 2);
    // Convert the padded fractional part to an integer
    const minutes = parseInt(paddedFractionalPartStr, 10);
    return { hours, minutes };
}
export function addTimes(time1, time2) {
    const time1Parts = convertToMinutes(time1);
    const time2Parts = convertToMinutes(time2);

    // Add hours and minutes separately
    let totalHours = time1Parts.hours + time2Parts.hours;
    let totalMinutes = time1Parts.minutes + time2Parts.minutes;

    // Handle cases where total minutes exceed 60
    if (totalMinutes >= 60) {
        totalHours += Math.floor(totalMinutes / 60);
        totalMinutes = totalMinutes % 60;
    }
    const total = totalMinutes === 0 ? `${totalHours}` : `${totalHours}.${totalMinutes.toString().padStart(2, '0')}`;
    // Format the result as hours.minutes
    const formattedTime1 = `${time1Parts.hours}.${time1Parts.minutes.toString().padStart(2, '0')}`;
    const formattedTime2 = `${time2Parts.hours}.${time2Parts.minutes.toString().padStart(2, '0')}`;

    // If the total matches either of the input times, return the matching time
    if (total === formattedTime1) {
        return time1;
    } else if (total === formattedTime2) {
        return time2;
    }
    // Otherwise, return the calculated total
    return total;
}

const setPropValue = (cellArray, index, value, fallbackValue = '') => {
    if (cellArray[index]) {
        cellArray[index].propValue = value !== 0 ? value : fallbackValue;
    }
};


export const getPlannedAndActualTimeForCells = (valueArray, hrmsData, listData) => {
    let totalCell = hrmsData ? JSON.parse(JSON.stringify(HRMSTimeSeriesChildColumnListData)) : JSON.parse(JSON.stringify(timeSeriesChildColumnListData));
    const results = hrmsData ? { HRMSWorkingTotalTime: 0 } : {
        plannedTotalTime: 0,
        actualTotalTime: 0,
        impedimentCount: 0,
        dependencyCount: 0,
        reason:0,
        taskEnded: '',
    };
    let isPlannedTimeZeroByUser
    let isActualTimeZeroByUser

    valueArray.forEach((cellValue) => {
        if (cellValue && typeof cellValue === 'object' && 'value' in cellValue) {
            cellValue = cellValue.value; // Extract the string from the 'value' property
          }
        const parsedCellValue = cellValue && isStringifiedArrayWithPropName(cellValue) ? JSON.parse(cellValue) : [];
        parsedCellValue.forEach(({ propName, propValue }) => {
            const parsedValue = parseFloat(propValue) || 0;
            // Use parseFloat for decimal values
            if (propValue != '') {
                switch (propName) {
                    case 'Planned Time':
                        results.plannedTotalTime = addTimes(results.plannedTotalTime, propValue);
                        isPlannedTimeZeroByUser = propValue === '0' ? true : false
                        if (isPlannedTimeZeroByUser !== true && isPlannedTimeZeroByUser !== undefined && results.plannedTotalTime === 0) {
                            isPlannedTimeZeroByUser = true
                        }
                        break;
                    case 'Actual Time':
                        results.actualTotalTime = addTimes(results.actualTotalTime, propValue);
                        isActualTimeZeroByUser = propValue === '0' ? true : false
                        if (isActualTimeZeroByUser !== true && isActualTimeZeroByUser !== undefined && results.actualTotalTime === 0) {
                            isActualTimeZeroByUser = true
                        }
                        break;
                    case 'Impediment':
                        if (propValue) results.impedimentCount += 1;
                        break;
                    case 'Reason':
                        break;
                    case 'Dependency':
                        if (propValue) results.dependencyCount += 1;
                        break;
                    case 'TaskEnded':
                        if (propValue === 'N') {
                            results.taskEnded = '';
                        }
                        else results.taskEnded = 'Y';
                        break;
                    case 'HRMS Working Hours':
                        if (propValue) results.HRMSWorkingTotalTime = addTimes(results.HRMSWorkingTotalTime, propValue);
                }
            }
        });
    });

    totalCell = JSON.parse(updateValues(totalCell, listData, true))
    // Update the totalCell values 
    if (hrmsData) {
        setPropValue(totalCell, 0, results.HRMSWorkingTotalTime, '');
    } else {
        setPropValue(totalCell, 0, results.plannedTotalTime, isPlannedTimeZeroByUser ? '0' : '');
        setPropValue(totalCell, 1, results.actualTotalTime, isActualTimeZeroByUser ? '0' : '');
        setPropValue(totalCell, 2, results.reason, '');
        setPropValue(totalCell, 3, results.dependencyCount, '');
        setPropValue(totalCell, 4, results.dependencyCount, '');
        
        // if (results.taskEnded) {
            setPropValue(totalCell, 5, results.taskEnded);
        // }
    }
    
    let result = JSON.stringify(totalCell)

    return result;
}
export function getParentMDVTotalValueAsRollUp(node, col, columnSubType) {
    if (!node || !node.childrenAfterAggFilter) return '';

    const values = [];

    const processChild = (child) => {
        if (child.childrenAfterAggFilter && child.childrenAfterAggFilter.length > 0) {
            const childRollupValue = getParentMDVValueAsRollUp(child, col, columnSubType);
            if (childRollupValue) {
                const parsedCellValue = isStringifiedArrayWithPropName(childRollupValue) ? JSON.parse(childRollupValue) : [];
                if (parsedCellValue.length > 0) values.push(parsedCellValue);
            }
        } else if (child.data && child.data.hasOwnProperty(col)) {
            const childValue = isStringifiedArrayWithPropName(child.data[col]) ? JSON.parse(child.data[col]) : [];
            if (childValue.length > 0) values.push(childValue);
        }
    };

    node.childrenAfterAggFilter.forEach(processChild);

    if (values.length === 0) return '';

    const rollupValue = JSON.parse(JSON.stringify(timeSeriesChildColumnListData));
    const results = {
        plannedTotalTime: 0,
        actualTotalTime: 0,
        impedimentCount: 0,
        dependencyCount: 0,
    };

    values.forEach((cellValue) => {
        cellValue.forEach(({ propName, propValue }) => {
            switch (propName) {
                case 'Planned Time':
                    results.plannedTotalTime += parseInt(propValue) || 0;
                    break;
                case 'Actual Time':
                    results.actualTotalTime += parseInt(propValue) || 0;
                    break;
                case 'Impediments':
                    results.impedimentCount += 1;
                    break;
                case 'Dependency':
                    results.dependencyCount += 1;
                    break;
            }
        });
    });

    rollupValue[0].propValue = results.plannedTotalTime || '';
    rollupValue[1].propValue = results.actualTotalTime || '';
    rollupValue[2].propValue = results.impedimentCount || '';
    rollupValue[3].propValue = results.dependencyCount || '';

    return JSON.stringify(rollupValue);
}

export const valueGetterForTotalTimeSeriesColumn = (params, start, end,totalField, listData) => {
    let dataObj =params.node?.data ?? params.data
    let field = totalField || params?.colDef?.field
    if (params.data) {
        let valueArrayTimeSeriesBlocks = getAllTimeSeriesCellsForARow(params.data, start, end);
        if(valueArrayTimeSeriesBlocks){
            let sum = getPlannedAndActualTimeForCells(valueArrayTimeSeriesBlocks ,params.data.checkinagent, listData);
            let data = JSON.parse(sum);
            // Filter out TaskEnded if propValue is empty or "No"
            data = data.filter(
                (item) => !((item.propName === "TaskEnded" && (!item.propValue || item.propValue === "No"))||item.propName === "Reason"
            ));

            // Convert the filtered data back to a JSON string
            sum = JSON.stringify(data);
        if (!dataObj[field + '_es']) {
            dataObj[field + '_es'] = { value: sum }
            dataObj[field] = sum
        }

        else if (dataObj[field + '_es'].value !== sum) {
            dataObj[field + '_es'].value = sum
            dataObj[field] = sum
        }
        return sum
    }}
}
const calculateAdjustedStartDate = (oldStart, newStart, frequency, extensionDirection) => {
    let oldStartDate = dayjs(oldStart).startOf('day');
    let newStartDate = dayjs(newStart).startOf('day');

    if (frequency === 'week') {
        //let weeksBetween = Math.floor(newStartDate.diff(oldStartDate, 'day') / 7);
        let daysToSubtract = ((newStartDate.day() - oldStartDate.day()) + 7) % 7;

        if (daysToSubtract !== 0) {
            newStartDate = newStartDate.subtract(daysToSubtract, 'day');
            // } else if (weeksBetween > 0) {
            //     newStartDate = newStartDate.subtract(weeksBetween * 7, 'day');
        }
    } else if (frequency === 'month') {
        let oldDayOfMonth = oldStartDate.date();  // Get the day of the month from old start date
        let newDayOfMonth = newStartDate.date();

        if (oldDayOfMonth !== newDayOfMonth) {
            // Adjust the new start date to match the old start date's day of the month
            newStartDate = newStartDate.date(oldDayOfMonth);

            // If the adjusted date exceeds the days in that month, set it to the last day of the month
            if (newStartDate.date() !== oldDayOfMonth) {
                newStartDate = newStartDate.endOf('month');
            }
        }
    }
    // Ensure the new start date is not the same as the old start date
    if (frequency === 'week') {
        newStartDate = extensionDirection==='left' ? newStartDate: newStartDate.add(1, 'week');
     } 
   else if (frequency === 'month' && newStartDate < dayjs(newStart).startOf('day')) {
        newStartDate = extensionDirection === 'left' ? newStartDate : newStartDate.add(1, 'month');
    }
    return newStartDate;
};

function generateDateArray(payloadToPrepareDateArray) {
    const {oldStart, start, end, frequency, groupId, columns, valueChangedByValueGetter, extendedDate, extensionDirection, listData } = payloadToPrepareDateArray
    const dateArray = [];
    // Function to format the date as "23 May 2024"
    const formatDate = (date) => dayjs(date).format('DD MMM YYYY');
    let date = extendedDate && frequency !== 'day' ? calculateAdjustedStartDate(formatDate(oldStart), formatDate(start), frequency, extensionDirection) : dayjs(start).startOf('day')
    const endDate = dayjs(end).startOf('day');
    const differenceInDays = endDate.diff(date, 'day');
    findAvailableSlotsForColumnNumbering(columns, differenceInDays + 1)
    let i = 0
    while (date.isBefore(endDate) || date.isSame(endDate)) {
        const formattedDate = formatDate(date);
        let day = new Date(date).getDay()
        let isWeekend = day === 0 || day === 6
        let columnDef = {
            field: date.format('MM-DD-YYYY'),
            headerName: formattedDate,
            colId: date.format('MM-DD-YYYY'),
            columnElasticid: uuidv4(),
            columnGroupShow: 'open',
            parent: groupId,
            deleteable: true,
            suppressMovable: false,
            block: 'timeseries',
            cellClass: (params) => {
                let classArray = ["global-style"]
                if (isWeekend) classArray.push('weekend')
                return classArray
            },
            valueSetter: (params) => {
                if (params.node && params.node?.data && params.colDef.type == "multi dimensional value" && !params.context.applyClick) {
                    let dataField = params.colDef.field;
                    let newVal = params.newValue
                    params.node.data[dataField] = newVal;
                    params.newValue = newVal;
                    if (params.node.data[dataField + '_es'] && params.node.data[dataField + '_es']?.value) params.node.data[dataField + '_es'].value = newVal;
                    return true
                }else{
                  params.context.applyClick = false;
                  return false;
              }
            }
        }
        SetTimeSeriesColumnProperties(columnDef, valueChangedByValueGetter, undefined, listData);
        dateArray.push(columnDef);

        // Increment date based on frequency
        if (frequency === 'day') {
            date = date.add(1, 'day');
        } else if (frequency === 'week') {
            date = date.add(1, 'week');
        } else if (frequency === 'month') {
            date = date.add(1, 'month');
        }
        i++
    }
    return dateArray;
}

export function generateTimeSeriesColumns(startDate, endDate, frequency, columnsSize, groupId, columns, valueChangedByValueGetter, allColumns, extendedDate, colDef, extensionDirection) {
    const oldStart = new Date(startDate);
    let colDefObject
    if (extendedDate) {
        colDefObject = JSON.parse(colDef.block);
    }
  
    const start = extendedDate
        ? (extensionDirection === "both" ? new Date(startDate) : extensionDirection === 'left'
            ? new Date(startDate)  // For left extension, new start date is the given start date
            : new Date(new Date(colDefObject.endDate).setDate(new Date(colDefObject.endDate).getDate() + 1)))  // Right extension: 1 day after the end date
        : new Date(startDate);

    const end = extendedDate
        ? (extensionDirection === "both" ?new Date(endDate) : extensionDirection === 'left'
            ? new Date(new Date(colDefObject.startDate).setDate(new Date(colDefObject.startDate).getDate() - 1))  // For left extension, end date is 1 day before the start date
            : new Date(endDate))  // Right extension: end date remains unchanged
        : new Date(endDate);

    let dateArray = [];

    const nextColumnSlot = findAvailableSlotsForColumnNumbering(extendedDate ? columns : allColumns, 1)
    if (!nextColumnSlot || nextColumnSlot.length == 0) return
    let totalColumn = {
        headerName: "Total", // Date formatted in format "23 May 2024"
        field: "Column" + nextColumnSlot[0], // Index of the element in the array converted to string,
        colId: "Column " + nextColumnSlot[0],
        type: "multi dimensional value",
        columnElasticid: uuidv4(),
        parent: groupId,
        width: '200px',
        block: 'timeseries',
        cellRenderer: 'multiDimensionalColumnRenderer',
        cellDataType: 'false',
        cellEditor: 'multiDimensionalValueTypeEditor',
        listData: timeSeriesChildColumnListData,
        editable: false,
        deleteable: true,
        suppressMovable: false,
        cellClass: getCellClass,
        cellStyle: getCellStyle,
         //valueGetter: (params) => valueGetterForTotalTimeSeriesColumn(params, oldStart, end),
    }
    dateArray.push(totalColumn)
    let allColumnsForFindingNextSlots = extendedDate ? [...columns, totalColumn] : [...allColumns, totalColumn]
    let listData;

    for (const data of columns) {
        if (data.block && data.children?.length) {
            listData = data?.children[1]?.children[0]?.listData;
            break;
        }
    }
    let payloadToPrepareDateArray = {
        oldStart,
        start,
        end,
        frequency,
        columnsSize,
        groupId,
        allColumnsForFindingNextSlots,
        valueChangedByValueGetter,
        extendedDate,
        extensionDirection,
        listData,
        columns
    }
    if (extensionDirection === 'both') {
        const leftStart = new Date(startDate);  // New start date for left extension
        const leftEnd = new Date(new Date(colDefObject.startDate).setDate(new Date(colDefObject.startDate).getDate() - 1));
        const rightEnd = new Date(endDate);  // Right extension: end date
        const rightStart = new Date(new Date(colDefObject.endDate).setDate(new Date(colDefObject.endDate).getDate() + 1));
    
        let leftPayload = {
            ...payloadToPrepareDateArray,
            start: leftStart,
            end: leftEnd
        };
    
        let rightPayload = {
            ...payloadToPrepareDateArray,
            start: rightStart,
            end: rightEnd,
            oldStart: leftEnd
        };
    
        let dateFieldColumnsForLeft = generateDateArray(leftPayload);
        let dateFieldColumnsForRight = generateDateArray(rightPayload);
    
        dateArray = [...dateArray, ...dateFieldColumnsForLeft, ...dateFieldColumnsForRight];
    } else {
        let dateFieldColumns = generateDateArray(payloadToPrepareDateArray)
        dateArray = [...dateArray, ...dateFieldColumns]
    } 

   
    return dateArray;

}

export function getAllChildrenOfaNode(node,gridRef){
    let children=[]
    const childrenArray = getUniqueChildrenArray(node)
    if(childrenArray && childrenArray.length>=1) {
        childrenArray.forEach((child)=>{
            if(child.id!==node.id){
                children.push(child)
            }
            
        })
    }
    return children;
}
export function updateSuccessorRows(newValue,row, predecessor, params, gridRef) {
    if (row.successorNodes && predecessor) {
      let successorIds = row.successorNodes.split(',').filter(Boolean); // Remove any empty strings
      let rowsToUpdate = [];
      let undoRowsSuccessor = [];
  
      successorIds.forEach(id => {
        let successorRowNode = params.api.getRowNode(id);
        if (successorRowNode && successorRowNode.data) {
          let successorRowData = successorRowNode.data;
          if (undoRowsSuccessor.length === 0) {
            undoRowsSuccessor.push(JSON.parse(JSON.stringify(successorRowData)));
          }
         else {undoRowsSuccessor.push(JSON.parse(JSON.stringify(successorRowData)));
      }
  
        //   successorRowData.predecessorNodes = removeEleFromStringWithCommaAsDelimiter(successorRowData.predecessorNodes, row.id);
        //   successorRowData[predecessor]=successorRowData.predecessorNodes
        //   successorRowData[predecessor+'_es']=updateOrCreateObject(successorRowData[predecessor+'_es'],"value",successorRowData[predecessor])
        //   row.successorNodes = removeEleFromStringWithCommaAsDelimiter( row.successorNodes, successorRowData.id);
          rowsToUpdate.push(successorRowData);
          rowsToUpdate.push(row);
        }
      });
      console.log(undoRowsSuccessor)
      params.api.applyTransactionAsync({
          update: rowsToUpdate,
        });
      return{updatedRows:rowsToUpdate,undoRows:undoRowsSuccessor}
    }
  }
  
export const addGroupParent=(col,parent)=>{
    return {
        ...col,parent: parent
        // ,columnGroupShow:"closed"
    }
}
export function fetchColumnsFromColIds(selectedColumns,gridRef,parent){
    let columns=[]
    let {canBeGrouped,truncatedSelectedColumns}=checkIfSelectedColumnsCanBeGrouped(selectedColumns,gridRef)
    if(truncatedSelectedColumns && canBeGrouped) {
        truncatedSelectedColumns.forEach((colId,index)=>{
            let column=gridRef.current.api.getColumnDef(colId)
            if(column){
                if(index!=0) column.columnGroupShow='open' 
                columns.push(addGroupParent(column,parent))
            }
            
        })
    }
    return columns;
}
export const fetchGridColumnConfigurationFromColIdArray=(selectedColumns,gridRef)=>{
    let columns=[]
    let colStateObj = makeColStateObj(gridRef.current.api.getColumnState());
    selectedColumns.forEach((colId)=>{
        let column = gridRef.current.api.getAllDisplayedColumns();
        column = column.find(function (colDef) {
           return colDef.colId === colStateObj[colId].colId;
       });
        if(column){
            columns.push(column)
        }
    })
    return columns;
}
function getMaxGroupColumnNumber(columns){
    let max = 1;

    // Iterate through columns to find the maximum group number
    columns.forEach(column => {
        if (column.children && column.children.length > 0 && column.headerName.includes("Group")) {
            const match = column.headerName.match(/Group\s*(\d+)/);
            if(!match) max=2
            if (match) {
                const number = parseInt(match[1], 10);
                if (number >= max) {
                    max = number + 1;
                }
            }
        }
    });

    // Ensure the resultant max number doesn't already exist
    while (columns.some(column => column.headerName === `Group ${max}`)) {
        max++;
    }

    return max;
}
export const makeColumnGroup=(selectedColumns,gridRef) => {
    let columnDefs=gridRef?.current?.api?.getColumnDefs()
    let maxGroupColumnNumber=getMaxGroupColumnNumber(columnDefs)
    let groupId=uuidv4()
    let columnGroup={
        headerName: maxGroupColumnNumber==1?"Group":`Group ${maxGroupColumnNumber}`,
        columnElasticid:groupId,
        colId:groupId,
        groupId
    } 
    let childrenColumns=fetchColumnsFromColIds(selectedColumns,gridRef,groupId)
    columnGroup.children=childrenColumns
    return {columnGroup,childrenColumns}
}
export const removeColumnFromGroup=(column,childColId)=>{
    let childrenColumns=traverseChildrenRecursivelyForColumns(column),groupCanBeDeleted=false
    childrenColumns= childrenColumns.filter(column=>column.colId!==childColId)
    childrenColumns=makeFirstColumnAlwaysVisibleUnderAGroup(childrenColumns)
    if(childrenColumns.length==0) groupCanBeDeleted=true
    return {parentColumn:{...column?.colDef,children:childrenColumns},childrenColumns,groupCanBeDeleted}

}
export const addColumnToGroup=(column,child,selectedCol,direction)=>{
    let childrenColumns=traverseChildrenRecursivelyForColumns(column)
    let insertIndex=0
    childrenColumns=childrenColumns.map((column,index)=>{
        if(column.colId===selectedCol.colId) insertIndex=index
        return column
    })
    if(direction==='right') insertIndex++
    childrenColumns.splice(insertIndex,0,child)
    childrenColumns=makeFirstColumnAlwaysVisibleUnderAGroup(childrenColumns)
    return {parentColumn:{...column,children:childrenColumns},childrenColumns}

}
export const removeGroupInfoFromColumn=(column)=>{
    delete column.parent
    delete column.columnGroupShow
    return column;
}

export function removeAFieldFromAllRows(gridRef, focusedColumn) {
    let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren
    let colToRemove = focusedColumn.colDef.field;
    // Process rows based on the presence of hrms
    const updatedRowData = rowData.reduce((acc, row) => {
        if (row?.data) {
            // Check if the row has hrms set to true
            if (row.data.checkinagent === true) {
                // Do not include this row in the result (i.e., delete the row)
                return acc; // Skip adding this row to the result
            } else {
                // Remove the specified column from rows where hrms is not true
                const dataCopy = { ...row.data }; // Shallow copy of the row data
                delete dataCopy[colToRemove];
                delete dataCopy[colToRemove + '_es'];
                
                // Add the updated row data to the result
                acc.push(dataCopy );
            }
        } else {
            // If there is no data, just add the row as is
            acc.push(row);
        }
        return acc;
    }, []);

    // Update the grid data
    gridRef.current.api.setGridOption(updatedRowData);
}

export function removePredecessorAndSuccessorNodes(gridRef, focusedColumn,rowsBeforeColumnDeletion){
    let rowData = gridRef.current.api.getModel().rootNode.allLeafChildren
    let newRowData = rowData.slice();
    const updatedRowData = newRowData.map(rowData => {
      if(rowsBeforeColumnDeletion)  
      rowsBeforeColumnDeletion.push(rowData);
        let updatedData = {...rowData.data };
        delete updatedData.successorNodes;
        delete updatedData.predecessorNodes;
        return updatedData; 
    });
    gridRef.current.api.setGridOption(updatedRowData)
}
export const removeColumnsFromGrid=(columns,gridRef)=>{
    let columnDefs=gridRef.current.api.getColumnDefs()
    let newColumns=columnDefs.filter(column=>!columns.includes(column.colId))
    return newColumns
}
const validateNewDate = (newDate, referenceDate, endCol, durationLimitInYears = 2) => {
    if (newDate === '' || newDate === undefined || newDate === null) {
        return true;
    }
    let formattedDate = processDate(newDate)
    if (!formattedDate || formattedDate === "Invalid Date") return false;
    let value = dayjs(formattedDate).format("MM/DD/YYYY");
    if (value === "Invalid Date" && newDate?.trim() !== '') {
        renderAlert('Invalid Date', 'error');
        return false;
    } else {
        const startDate = endCol ? referenceDate ? new Date(referenceDate) : '' : new Date(newDate);
        const endDate = endCol ? new Date(newDate) : new Date(referenceDate);
        const durationLimitInMs = durationLimitInYears * 365 * 24 * 60 * 60 * 1000; // Convert years to milliseconds 
        if (startDate && endDate && endDate !== 'Invalid Date' && startDate !== 'Invalid Date') {
            const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
            const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
            startDateOnly.setHours(0, 0, 0, 0); // Set to midnight
            endDateOnly.setHours(0, 0, 0, 0);   // Set to midnight

            if (endDateOnly.getTime() < startDateOnly.getTime() && endCol) {
                renderAlert("End date can't be less than the start date.", 'info');
                return false;
            }
            else if (endDateOnly.getTime() < startDateOnly.getTime() && !endCol) {
                renderAlert("Start date can’t be greater than end date.", 'info');
                return false;
            }
            else if (Math.abs(endDateOnly - startDateOnly) > durationLimitInMs) {
                renderAlert('The duration between the dates should not exceed 2 years.', 'info');
                return false; // Exceeds duration limit
            }
        }
        else return true
    }
    return true; // Valid new date
};

export const validateAndFormatDate = (params, newValue, oldValue) => {
    newValue= processDate(newValue)
    let startDateCol = params.colDef.linkedColumns.startDate;
    let endDateCol = params.colDef.linkedColumns.endDate;

    let startDate = params.data[startDateCol];
    let endDate = params.data[endDateCol];
    const formattedDate = oldValue?.trim() !== "" ? processDate(oldValue,true) : ""
    const value = formattedDate ? dayjs(formattedDate).format("MM/DD/YYYY") : "" 
    const date =value === "Invalid Date" || value=='' ? '' : new Date(value);
    const oldValueOfDate =  date ? `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}` : "";
 
    const isInvalidDate = (newVal, compareDate, isStart) => {
        return !validateNewDate(newVal, compareDate, isStart);
    };

    const shouldRevert = (newVal, oldVal, compareDate, isStart) => {
            if (isInvalidDate(newVal, compareDate, isStart)) {
                if (isInvalidDate(oldVal, compareDate, isStart)) {
                    return '';
                } else {
                    return oldVal;
                }
            }
            return null;
    };

    if (endDateCol && endDateCol!=params.colDef.field) {
        const result = shouldRevert(newValue, oldValueOfDate, endDate, false);
        if (result !== null) return result;
    } else if (startDateCol) {
        const result = shouldRevert(newValue, oldValueOfDate, startDate, true);
        if (result !== null) return result;
    }
    return newValue; // Valid new date
};
export const checkForEmptyNotes = (content) => {
    if (content === "Notes example") return false
    if (content !== undefined && content !== '' && content !== null && content !== "undefined") {
        const notes = JSON.parse(content);
        const filteredNotes = notes.filter(note =>
            note.children.some(child => child?.text?.trim() !== "")
        );
        if (filteredNotes.length === 0) {
            return true;
        }
        else
            return false
    }
    return true
}
export const makeParentCellNotEditable = (params, columnDef) => {
    const hasSubTasks = params?.node?.childrenAfterAggFilter?.length > 0 || params?.node?.allLeafChildren?.length > 0;
    const currentSheet = store.getState().sheetReducer.currentSelectedSheet;
    // HRMS data check: Make it uneditable and show alert
    if (params?.data?.checkinagent) {

        renderAlert('The data in this cell is sourced from the HRMS application and cannot be modified.', 'info');
        return false;
    }
    else if(params?.data?.isAzureRow){
        renderAlert('The data in this cell is sourced from the Azure application and cannot be modified.', 'info');
        return false;
      }

    let isMDVRollupApplicable = false;
    // Types that depend on sub-tasks for editability
    if(columnDef?.type === "multi dimensional value"){
        let listData = columnDef?.listData;
        isMDVRollupApplicable = typeof listData === 'string' ? checkIfRollupEnabledInMDV(JSON.parse(listData)) : checkIfRollupEnabledInMDV(listData);

    }
    const subTaskDependentTypes = ['Max', 'Min','Sum','Avg', 'shareableRollupList', 'status', 'duration','predecessor'];
    if (subTaskDependentTypes?.includes(columnDef?.rollup) || subTaskDependentTypes?.includes(columnDef?.type) || (columnDef?.type === 'multi dimensional value' && columnDef?.block) || (columnDef?.type === 'multi dimensional value' && isMDVRollupApplicable)) {
        if (hasSubTasks &&!columnDef?.azureColumn) {
            renderAlert('This row has sub-tasks and cannot be edited directly. Edit cells beneath this row to change this value.', 'info');
            return false;
        }
    }
    // Default: Editable if none of the conditions block editing
    return true;
};

export const isValidPerson = (val) => {
    try {
        let parsedArray;
        if (typeof val === 'string') {
            try {
                parsedArray = JSON.parse(val);
            } catch (e) {
                parsedArray = null;
            }
        } else {
            parsedArray = val;
        }
        
        if (!Array.isArray(parsedArray)) {
            return false;
        }
        // Helper function to check if an object is a valid person
        const isValidPersonObject = (obj) => {
            return typeof obj === 'object' &&
                obj !== null &&
                typeof obj.username === 'string' &&
                obj.username.trim() !== '' &&
                typeof obj.email === 'string' &&
                obj.email.trim() !== '' &&
                obj.email.includes('@'); // Basic email validation
        };
        // Validate each object in the array
        return parsedArray.every(isValidPersonObject);
    } catch (e) {
        console.error("Error parsing or validating value", e);
        return false; 
    }
};
export const  formatAssigneeValue=(value)=> {
    try {
        // Try parsing the value to check if it's in JSON format
        const parsedValue = JSON.parse(value);
        if (Array.isArray(parsedValue)) {
          const transformedArray = parsedValue.map(item => {
            const transformedItem = {};
            for (const key in item) {
              let formattedKey = key.trim();
              if (formattedKey === 'User Email') {
                formattedKey = 'email'; // Replace 'User Email' with 'email'
              } else {
                formattedKey = formattedKey.toLowerCase(); // Convert other keys to lowercase
              }
              transformedItem[formattedKey] = item[key];
            }
            return transformedItem;
          });
          
          return JSON.stringify(transformedArray);
        }}
    catch (e) {
    const object = {};
    const keyValuePairs = value.split(',');
  
    keyValuePairs.forEach(pair => {
      const [key, val] = pair.split(': ');
      let formattedKey = key.trim();
      if (formattedKey === 'User Email') {
        formattedKey = 'email'; // Replace 'User Email' with 'email'
      } else {
        formattedKey = formattedKey.toLowerCase(); // Convert other keys to lowercase
      }      object[formattedKey] = val;
    });
    console.log('error---', e)
    // Return the object in the desired JSON array string format
    return JSON.stringify([object]);
  }};
  export const parsePersonColValue = (cellValue, memoizedUsedInitials, colType) => {
    let value;

    const isPersonType = colType === 'person' || colType === 'Assignee';

    try {
        let parsedValue = cellValue;

        // Try parsing JSON only if it's a non-empty string
        if (typeof cellValue === 'string' && cellValue.trim() !== '') {
            try {
                parsedValue = JSON.parse(cellValue);
            } catch (e) {
                parsedValue = cellValue; // fallback to original string
            }
        }

        // Handle number type (wrap in array of string)
        if (typeof parsedValue === 'number') {
            value = [parsedValue.toString()];
        }

        // Handle person/assignee column
        else if (isPersonType) {
            if (Array.isArray(parsedValue)) {
                value = parsedValue
                    .filter(item => (item.username || item.Username) && (item.email || item["User Email"]))
                    .map(item => ({
                        username: item.username || item.Username,
                        initials: item.initials ? item.initials : getInitials(item, memoizedUsedInitials)
                    }));
            } else if (parsedValue?.username && parsedValue?.email) {
                value = [{
                    username: parsedValue.username,
                    initials: parsedValue.initials ? parsedValue.initials : getInitials(parsedValue, memoizedUsedInitials)
                }];
            }
        }

        // Handle non-person columns (fallback to delimiter-based split)
        else {
            if (parsedValue?.includes(", ")) {
                value = parsedValue.replace(/, /g, "⊗⇔≈");
                value = value.split("⊗⇔≈");
            }
            else {
                value = cellValue.split('⊗⇔≈');
            }
        }

    } catch (error) {
        if (process.env.NODE_ENV === 'development') {
            console.warn("Failed to parse cell value:", cellValue, error);
        }

        // Fallback logic in case of full failure (non-person columns only)
        if (!isPersonType && typeof cellValue === 'string') {
            if (cellValue.includes(', ')) {
                value = cellValue.replace(/, /g, "⊗⇔≈");
                value = value.split("⊗⇔≈");
                } 
                else {
                value = cellValue.split('⊗⇔≈');
            }
        }
    }

    // Handle array input directly (outside try block)
    if (Array.isArray(cellValue)) {
        try {
            const first = cellValue[0];
            const parsed = typeof first === 'string' ? JSON.parse(first) : first;

            if (Array.isArray(parsed)) {
                value = parsed
                    .filter(item => item.username && item.email)
                    .map(item => ({
                        username: item.username,
                        initials: item.initials ? item.initials : getInitials(item, memoizedUsedInitials)
                    }));
            } else if (parsed?.username && parsed?.email) {
                value = [{
                    username: parsed.username,
                    initials: parsed.initials ? parsed.initials : getInitials(parsed, memoizedUsedInitials)
                }];
            }
        } catch (e) {
            // Fallback if array parsing fails
            value = cellValue.map(String);
        }
    }

    // Final clean-up
    if (Array.isArray(value)) {
        value = value.filter(item => item !== null && item !== '' && item !== undefined);
    }

    return value;
};

export const getInitials = (user, usedInitials,type="general") => {
    if(user){
        const { username, email } = user; // Destructure username and email from the user object
        if (!username || !email || email === undefined || email === null || email === '') {
            return '';
        }
    
        // If either username or email is missing, return an empty string
    
        if (!username) return ''; // Return an empty string if username is not provided
        const nameParts = username.split(' ');
        let initials = nameParts.map(part => part.charAt(0).toUpperCase()).join('');
        // Ensure initials are unique
        let uniqueInitials = initials;
        let suffix = 1;
        if((type === "general"||type==="fromAutoComplete") && type!== 'selectedTags'){
        while (usedInitials?.some(item => (item?.initial === uniqueInitials||item?.initials === uniqueInitials) && item.username !== username)) {
            uniqueInitials = `${initials}${suffix}`;
            suffix++;
            }
        }
        // Add the unique initials along with username and email to the list
        if (email.endsWith("@thedigitalgroup.com") && type !== 'selectedTags') {
            const alreadyExists = usedInitials?.some(item => item?.email === email);
            if (!alreadyExists) {
                usedInitials.push({ username, email, initial: uniqueInitials });
            }
        }
    
        return uniqueInitials;    
    }
};

export const addInitialsToListData = (listData, memoizedUsedInitials) => {
    // Parse the JSON string to an array of objects
    let listDataArray = JSON.parse(listData);
    // Map through the array and add initials if not already present
    listDataArray = listDataArray.map(user => {
        if (!user?.initials) { // Check if initials are not present
            return { ...user, initials: getInitials(user, memoizedUsedInitials) };
        }
        else{
            memoizedUsedInitials.push({ username:user.username, email:user.email, initial: user.initials });
        }
        return user;
    });

    // Convert the updated array back to a JSON string
    return JSON.stringify(listDataArray);
};
export const thereisAlreadyATimeSeriesGroup = (columns) => {
    for (let i = 0; i < columns.length; i++) {
        let col = columns[i];
        if (col.block) {
            let parsedBlock = JSON.parse(col.block);
            if (parsedBlock && parsedBlock.type === 'timeseries') {
                return true;
            }
        }
    }
    return false; // If no timeseries block is found, return false
};

export const findDragToIndexForGroupColumn = (params, newColDefs, setColumnDefs) => {
    const toIndex = params.toIndex;
  
    // Recursive function to traverse column definitions, including nested children
    const traverseColDefs = (colDefs, count = 0) => {
      for (let i = 0; i < colDefs.length; i++) {
        count++;
        // Check if the column has children (nested group)
        if (colDefs[i].children) {
          if(!colDefs[i].parent) count--
          let {countVar} = traverseColDefs(colDefs[i].children, count);  // Recursively count children
          count = countVar
          
        }

        
        // If the count exceeds or matches the target index, return the current index
        if (count >= toIndex) return { index: i, countVar:count };
      }
      return { index: colDefs.length, countVar:count };
    };
  
    // Start traversing the top-level column definitions
    const { index } = traverseColDefs(newColDefs);
    return index;
  };
export const parsePersonListData=(listData)=> {
    if (typeof listData !== "string") {
        console.warn("listData is not a string:", listData);
        return null;
    }
    try {
        const parsedData = JSON.parse(listData);
        
        if (Array.isArray(parsedData)) {
            const validData = parsedData.filter(
                (user) =>
                  typeof user?.username === "string" &&
                  user?.username.trim() !== "" &&
                  typeof user.email === "string" &&
                  user.email.trim() !== ""
              );
            return {
                usernames: validData.map(user => user?.username),
                emails: validData.map(user => user.email)
            };
        } 
    } catch (error) {
        console.log('error---', error)
        return null;
    }
}
export function deepCopy(obj, excludeFields = [], map = new WeakMap()) {
    // Return primitive or Date
     // Return primitives as they are
     if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }

    // Handle existing reference from map
    if (map.has(obj)) {
        return map.get(obj);
    }

    // Prepare target (array or object)
    const copy = Array.isArray(obj) ? [] : {};

    // Register in map early to support circular refs
    map.set(obj, copy);

    Object.keys(obj).forEach(key => {
        if (!excludeFields.includes(key)) {
            copy[key] = deepCopy(obj[key], excludeFields, map);
        }
    });

    return copy;
}

export const traverseChildrenRecursivelyForColumns=(column)=>{
    if(column.children && column.children[0] && (column.children[0]?.colDef?.field || column.children[0].field )) return column.children;
    else if(column.children && column.children.length) return traverseChildrenRecursivelyForColumns(column.children[0])
    else return column.children
}

export const traverseChildrenRecursivelyForColumnsWhereGroupingIsMultiLevel = (column,allChildren =[])=>{
    if(column.colDef  || column.providedColumnGroup?.colGroupDef || column){
        if(column.providedColumnGroup?.colGroupDef?.field || column.colDef?.field || column.field) allChildren.push(column);
        else if(column.children){
            column.children.forEach((childCol)=>{
               return traverseChildrenRecursivelyForColumnsWhereGroupingIsMultiLevel(childCol,allChildren)

            })
        }
    }
    return allChildren
}

export const recursivelyCalculateParent =(column)=>{
    if(column.parent && column.parent.providedColumnGroup?.colGroupDef?.headerName) return column.parent;
    else if(column.parent) return recursivelyCalculateParent(column.parent);
    else return column
}
export const recursivelyCalculateParentTillTop =(column)=>{
    if(column?.originalParent) return recursivelyCalculateParentTillTop(column?.originalParent);
    else if( column?.providedColumnGroup?.colGroupDef?.headerName) return column;
    else return column
}
export const getFlatChildrenColumnOfTimeSeries = (columns, flatChildren = []) => {
    if (columns && columns.length) {
        columns.sort((a, b) => {
            const [monthA, dayA, yearA] = a.colId.split('-').map(Number);
            const [monthB, dayB, yearB] = b.colId.split('-').map(Number);
            const dateA = new Date(yearA, monthA - 1, dayA); // month is zero-based
            const dateB = new Date(yearB, monthB - 1, dayB);
            return dateA - dateB;
        });
        columns.forEach((col) => {
            if (col.field) flatChildren.push(col);
            else if (col.children) {
                return getFlatChildrenColumnOfTimeSeries(col.children, flatChildren)
            }
        })
    }
    return flatChildren
}

export const findColumnByTypeOrField = (columns, columntype, field) => {
  if(columns){
    for (const column of columns) {
        if (column.type === columntype) {
            if (field && column.field === field) {
                return column;
            }
            else if (!field) return column;
        }

        // Check if the column has children and recursively search them
        if (column.children && column.children.length > 0) {
            const result = findColumnByTypeOrField(column.children, columntype, field);
            if (result) {
                return result;
            }
        }
    }}
    // Return false if no predecessor column is found
    return false;
};

export const findEndDateColumnField = (columns) => {
    let predeccessorColumn = findColumnByTypeOrField(columns, 'predecessor')
    if (predeccessorColumn && predeccessorColumn.linkedColumns) {
        return predeccessorColumn.linkedColumns.predecessorEndDate
    }
    return false
}

export const findStartDateColumnField = (columns) => {
    let predeccessorColumn = findColumnByTypeOrField(columns, 'predecessor')
    if (predeccessorColumn && predeccessorColumn.linkedColumns) {
        return predeccessorColumn.linkedColumns.predecessorStartDate
    }
    return false
}

const getValidDates = async (dates, endDate) => {
    const endDateObj = new Date(endDate);

    // Collect dates up to the end date
    const result = [];
    for (let date of dates) {
        const currentDate = new Date(date);
        if (currentDate > endDateObj) break; // Stop if the current date is beyond the end date
        result.push(date);
    }

    return result;
}

export const findAllTimeSeriesColumnFieldsTillSpecifiedEndDate = async (parentColumn, startDate, endDate) => {
    startDate = dayjs(startDate, "MM/DD/YYYY").format("MM-DD-YYYY")
    let flatColumnList = getFlatChildrenColumnOfTimeSeries(parentColumn.providedColumnGroup.colGroupDef.children)
    let StartColumnVisible = false, endColumnVisible = false, rollupColumns = []
    let arrayOfFields = []
    let isTimeSeriesTotalColumnPresent
    for (const column of flatColumnList) {
        let currentColumnField = column.field;
        if (calculateDayDifference(startDate, currentColumnField) === 0) StartColumnVisible = true;
        if (calculateDayDifference(endDate, currentColumnField) === 0) endColumnVisible = true;
        if (column?.block === 'timeseries' && column.headerName === 'Total') {
            isTimeSeriesTotalColumnPresent = column;
        }
        if (StartColumnVisible) {
            let day = new Date(currentColumnField).getDay()
            let isWeekend = day === 0 || day === 6
            if (!isWeekend) {
                rollupColumns.push(column);
                arrayOfFields.push(currentColumnField);
            }
        }
        // Stop if end column is visible
        if (endColumnVisible) break;
    }

    // Filter dates strictly up to the `endDate`
    const dates = await getValidDates(arrayOfFields, endDate);
    return { allTimeSeriesFieldsTillEndDate: dates, rollupColumns, isTimeSeriesTotalColumnPresent }; // Return the final filtered list
};

export const clearRowValues = (row, colDef, params, undoData) => {
    row[colDef.field] = '';
   if(row[colDef.field + '_es']?.value) row[colDef.field + '_es'].value = '';

    if (colDef.linkedColumns.predecessor) {
         clearPredecessorFields(row, colDef, params);
        clearDurationFields(row, colDef);
    }
};

export const clearPredecessorFields = (row, colDef, params,undoData) => {
    row[colDef.linkedColumns.predecessor] = '';
    if (row[colDef.linkedColumns.predecessor + '_es']) {
        row[colDef.linkedColumns.predecessor + '_es'].value = '';
    } else if(undoData){
        updateOrCreateObject(undoData[colDef.field + '_es'], "value", params?.oldValue);
    }
};

export const clearDurationFields = (row, colDef) => {
    row[colDef.linkedColumns.duration] = '';
  if(row[colDef.linkedColumns.duration + '_es'] && row[colDef.linkedColumns.duration + '_es']?.value)  row[colDef.linkedColumns.duration + '_es'].value = '';
};

// export const getSuccessorIdsAndPredecessorIds = (row) => {
   
//     const predecessorIds = row['predecessorNodes']?.split(',').filter(Boolean) || [];
//     const successorIds = row['successorNodes']?.split(',').filter(Boolean) || [];
    
//     return { predecessorIds, successorIds };
// };

// export const prepareUndoRowData = (undoData, ids, api, row,predecessorCol) => {
    
//     let undoRowAfterDeletingDate = []; // Array to store the undo data
//     let rowsToUpdate = [];

//     // Process both predecessor and successor nodes
//     const { predecessorIds, successorIds } = ids;

//     // Loop through successor IDs
//      predecessorIds.forEach(id => {
//         const predecessorRowNode = api.getRowNode(id);
//         if (predecessorRowNode && predecessorRowNode.data) {

//             const predecessorRowData = predecessorRowNode.data;
//             let oldRowData = JSON.parse(JSON.stringify(predecessorRowData));
//             undoRowAfterDeletingDate.push({
//                 id: predecessorRowData.id, // Use the appropriate property for ID
//                 column: predecessorCol, // Pass the column definition if necessary
//                 value: oldRowData['predecessorNodes'], // Previous value or relevant data
//                 rowData: oldRowData, // Use predecessorRowData for consistency
//                 index: predecessorRowNode.rowIndex // Use the correct index for the predecessor
//             });

//             // Remove the current row ID from successor nodes
//              predecessorRowData['predecessorNodes'] = removeEleFromStringWithCommaAsDelimiter(predecessorRowData['predecessorNodes'], row.id);
          
           
//          rowsToUpdate.push(predecessorRowData);
//  } });

//     //Loop through predecessor IDs (if needed)
//     successorIds.forEach(id => {
//         const successorRowNode = api.getRowNode(id);
//         if (successorRowNode && successorRowNode.data) {
//             const successorRowData = successorRowNode.data;
//             const oldRowData = JSON.parse(JSON.stringify(successorRowData));
//             undoRowAfterDeletingDate.push({
//                 id: successorRowData.id, // Use the appropriate property for ID
//                 column: predecessorCol, // Pass the column definition if necessary
//                 value: oldRowData['successorNodes'], // Previous value or relevant data
//                 rowData: oldRowData, // Use predecessorRowData for consistency
//                 index: successorRowNode.rowIndex // Use the correct index for the predecessor
//             });
        
//             // Remove the current row ID from predecessor nodes
//             successorRowData['successorNodes'] = removeEleFromStringWithCommaAsDelimiter(successorRowData['successorNodes'], row.id);
//             let valArray = successorRowData[predecessorCol]?.split(",");
//             let nodeArrayInString = '';

//             let newPredecessorValue;
//             valArray?.forEach(element => {
//                 let trimmedElement = element.trim();
//                 let parts = trimmedElement.split('+');
//                 let eleId = parts[0];
//                 let duration = parts[1] ? parts[1].trim() : ''; // Extract duration part if present
        
//               if(eleId==row.id) {
//                     newPredecessorValue =removeEleFromStringWithCommaAsDelimiter(eleId, row.id);   
//                 }
//         else {
//               nodeArrayInString+=eleId + (duration ? '+' + duration : '');}
           
//         })
//         successorRowData[predecessorCol]=nodeArrayInString
//         if(successorRowData[predecessorCol] &&successorRowData[predecessorCol].value) 
//         successorRowData[predecessorCol+'_es'].value=nodeArrayInString
//             rowsToUpdate.push(successorRowData);
//         }
//     });

//     return {undoRows:undoRowAfterDeletingDate, updatedRows: rowsToUpdate };
// };
const determineColumnFields = (
    newValue,
    row,
    colDef,
    predecessorStartDate,
    predecessorEndDate,
    isPredecessorColumnEdit,
    isDurationColumnEdit,
    endDate,
    startDate,
    predecessor,
    originalDuration,
    gridRef
) => {
    let columnField, updatedNewValue, predecessorEndDateCol, endDateCol, startDateCol, predecessorCol,durationCol;
    switch (true) { 
        case isDurationColumnEdit:
            columnField = predecessorStartDate||startDate 
            updatedNewValue = row[predecessorEndDate]
            predecessorEndDateCol = predecessorEndDate
            startDateCol = predecessorStartDate||startDate 
            endDateCol = predecessorEndDate
            predecessorCol = predecessor
            durationCol=colDef.field
            break;

        case isPredecessorColumnEdit:
            columnField = colDef.linkedColumns.predecessorStartDate ||startDate ;
            updatedNewValue = row[predecessorEndDate];
            predecessorEndDateCol = predecessorEndDate;
            startDateCol = predecessorStartDate||startDate 
            endDateCol = predecessorEndDate
            predecessorCol = colDef.field
            let endDateColumn = findColumnUsingParamsOrGridRef(gridRef.current, 'date',predecessorEndDateCol)
            durationCol= endDateColumn.linkedColumns.duration;
            break;

        default:
            predecessorEndDateCol = predecessorEndDate ? predecessorEndDate :predecessorStartDate ? colDef.field : predecessorEndDate;
            columnField = predecessorStartDate||startDate ? colDef.linkedColumns.predecessorStartDate||startDate : colDef.field;
            updatedNewValue = predecessorStartDate ? newValue : row[predecessorEndDateCol];
            startDateCol = predecessorStartDate || startDate ? predecessorStartDate || startDate : colDef.field;
            endDateCol =predecessorEndDate ? predecessorEndDate : predecessorStartDate ? colDef.field : endDate;
            predecessorCol = colDef?.linkedColumns?.predecessor
            durationCol=originalDuration;
            break;
    }
    return { columnField, updatedNewValue, predecessorEndDateCol, endDateCol, startDateCol, predecessorCol ,durationCol};
};
export const processSuccessorNodes = (newValue, row, colDef, parentRowsToUpdate, gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate, isPredecessorColumnEdit, isDurationColumnEdit, changedSuccessorRows = [], undoRows = [], originalRow) => {
    const {loggedInUser} = xTablesStore.getState().gridReducer

    if (((predecessorStartDate||startDate )|| colDef.field !== predecessorEndDate) && row.successorNodes) {
        // Call the helper function to determine column fields
        const { columnField, updatedNewValue, predecessorEndDateCol, endDateCol, startDateCol, predecessorCol,durationCol } = determineColumnFields(
            newValue,
            row,
            colDef,
            predecessorStartDate,
            predecessorEndDate,
            isPredecessorColumnEdit,
            isDurationColumnEdit,
            endDate,
            startDate,
            predecessor,
            duration,
            gridRef
        );
        const { changedSuccessorRows: localChanged, undoRows: localUndo } = getStartDateForSuccessors(
            updatedNewValue,
            row.successorNodes,
            columnField,
            colDef,
            predecessorCol,
            endDateCol,
            row,
            predecessorEndDateCol,
            isPredecessorColumnEdit,
            isDurationColumnEdit,
            gridRef,
            changedSuccessorRows,
            originalRow,
            loggedInUser
        );
        // Accumulate changes in the referenced arrays
        changedSuccessorRows.push(...localChanged);
        undoRows.push(...localUndo);
        // Process each successor row
        localChanged?.forEach((singleRow) => {
            // Calculate new end date based on start date change
            let newValueForEndDate
            if (predecessorStartDate) {
                newValueForEndDate = returnEndDateIfStartIsChanged(startDateCol, endDateCol, durationCol, singleRow);
            } else {
                newValueForEndDate = returnEndDateIfStartIsChanged(startDateCol, endDateCol, durationCol, singleRow);
            }
            let oldEndDateValue=singleRow[endDateCol]
            // Update end date fields
            singleRow[endDateCol + '_es'] = updateCellValue(singleRow,endDateCol + '_es',"value",newValueForEndDate,loggedInUser)
            singleRow[endDateCol] = newValueForEndDate;
            // singleRow[endDateCol + '_es']= updateOrCreateObject(singleRow[endDateCol + '_es'], 'value', newValueForEndDate)

            // Process duration if it's undefined or empty
            if (singleRow[durationCol] === undefined || singleRow[durationCol] === '' || singleRow[durationCol] === null) {
                singleRow = processDuration(singleRow, durationCol, startDateCol, endDateCol, colDef,'',"","",loggedInUser);
            }
            // Recursively process successor nodes for the current row if they exist
            if (singleRow.successorNodes && singleRow.successorNodes.length > 0) {
                processSuccessorNodes(
                    newValue,
                    singleRow,
                    colDef,
                    parentRowsToUpdate,
                    gridRef,
                    predecessorStartDate,
                    predecessorEndDate,
                    predecessor,
                    duration,
                    endDate,
                    startDate,
                    isPredecessorColumnEdit,
                    isDurationColumnEdit,
                    changedSuccessorRows, // Pass by reference
                    undoRows, // Pass by reference,
                    row,
                    loggedInUser
                );
            }
        });
        return ({ changedSuccessorRows: changedSuccessorRows, undoRows: undoRows })
    }
};


export const checkForCorrectDateFormat = (newValue, params,oldDate) => {
    // Format new value
    newValue=processDate(newValue)
    let formattedDate = newValue?.trim() !== "" ? processDate(newValue) : '';
    let value = formattedDate ? dayjs(formattedDate).format("MM/DD/YYYY") : '';
    // Format old value
    const formattedOldDate = oldDate?.trim() !== "" ? processDate(oldDate,true) : "";
    const formatOldValue = formattedOldDate ? dayjs(formattedOldDate).format("MM/DD/YYYY") : "";

    // Validate and format the old date
    const date = formatOldValue === "Invalid Date" || formatOldValue === '' ? '' : new Date(formatOldValue);
    const oldValueOfDate = date ? `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}` : "";
    if (
        formattedDate !== null && 
        formattedDate !== undefined && 
        formattedDate !== "Invalid Date" && 
        (value === "Invalid Date" || (value.trim() === '' && newValue !== ''))
    ) {
        renderAlert("Invalid date", "error");
    }
    
    let result = value === "Invalid Date" || (value.trim() === '' && newValue !== '') ? oldValueOfDate || "" : value;
    // Return the new value or old value based on validation
    return result
};

// // Function to create undo data
// const createUndoData = (params) => ({
//     id: params.node.data.id,
//     column: params.colDef.field,
//     value: params.oldValue || "",
//     rowData: { ...params.node.data },
//     index: params.node.rowIndex,
// });

// const getRowsToUpdate = (nodeData, updatedRows) => {
//     // Ensure rowsToUpdate is initialized as an array
//     let rowsToUpdate = Array.isArray(nodeData) ? nodeData : [nodeData];
//     return (rowsToUpdate || []).concat(updatedRows);
// };

// const getRowsToUndo = (undoData,undoRows) => {
//     // Ensure rowsToUndo is initialized as an array
//     let updatedUndoRows= Array.isArray(undoData) ? undoData : [undoData];
//     return (updatedUndoRows || []).concat(undoRows);
// };

// const populateUndoRowData = (rowsToUpdate, rowsToUndo) => {
//     let undoRowData = [];
//     rowsToUndo.forEach((undoRow, index) => {
//         const correspondingRow = rowsToUpdate[index] || {}; // Get the matching updated row for each undo row
//         undoRowData.push({
//             row: correspondingRow, // Correctly matched updated row
//             undoRow: undoRow // The undo row that corresponds to it
//         });
//     });
//     return undoRowData;
// };

// export const dateValueSetter = (params, valueChangedByValueGetter) => {
//     if (params.node && params.node?.data && params.colDef.type === "date") {
//         const undoData = createUndoData(params);

//         let dataField = params.colDef.field;
//         params.node.data[dataField] = params.newValue?.trim();

//         if (params.node.data[dataField + '_es'] && params.node.data[dataField + '_es']?.value) {
//             params.node.data[dataField + '_es'].value = params.newValue?.trim();
//         }

//         if (params.oldValue !== params.newValue && (params.newValue?.trim() === '' || params.newValue === null || params.newValue === undefined)) {
//             if (params.colDef?.linkedColumns?.predecessor) {
//                 const { predecessorIds, successorIds } = getSuccessorIdsAndPredecessorIds(params.node.data);
//                 const { undoRows, updatedRows } = prepareUndoRowData(undoData, { predecessorIds, successorIds }, params.api, params.node.data, params.colDef?.linkedColumns?.predecessor);

//                 clearRowValues(params.node.data, params.colDef, params);
//                 params.node.data['predecessorNodes'] = '';
//               //  params.node.data['successorNodes'] = '';

//                 const rowsToUpdate = getRowsToUpdate(params.node.data, updatedRows);
//                 const rowsToUndo = getRowsToUndo(undoData,undoRows);

//                 const undoRowData = populateUndoRowData(rowsToUpdate, rowsToUndo);
//                 valueChangedByValueGetter(params.node, params.colDef.field, params.newValue?.trim(), params, '', undoRowData);
//                 return params.newValue?.trim();
//             }
//         }

//         return params.newValue?.trim();
//     }
// };

// function to add undo row entry
export const addUndoRow = (row, field,column, value, index, itemData,cellValueCallbackArray) => {
    cellValueCallbackArray.current.calls.push({
        row: row,
        undoRow: {
            id: itemData.id,
            column:column,
            value: value,       // Original field value for undo
            rowData: itemData,  // Original row data for undo
            index: index        // Adjusted index
        }
    });
};
// Function to extract undoRow.rowData from cellValueCallbackArray.current.calls
// export const extractUndoData=(calls)=> {
//     const undoDataForPopup = [];
//     calls.forEach((call) => {
//         if (call.undoRow && call.undoRow.rowData) {
//             undoDataForPopup.push(call.undoRow.rowData);
//         }
//     });
//     return undoDataForPopup;
// }

// Open predecessor warning dialog and store change data
export const openPredecessorWarning = (params, setPendingChange, setPredecessorWarningDialogOpen, newValue, undoDataForPopup, updatedRows, showPredecessorWarningWhileEditing,gridRef) => {
    const filteredUpdatedRows = [];
    const cellRanges = params.api.getCellRanges()
    let newRowData = gridRef.current.api.getModel().rootNode.allLeafChildren
    let selectedNodes = params.api.getSelectedNodes();
    if (cellRanges && cellRanges.length > 0 && selectedNodes.length === 0) {
        let start = Math.min(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex),
            end = Math.max(cellRanges[0].startRow.rowIndex, cellRanges[0].endRow.rowIndex);
        if (end - start >= 0) {
            for (let i = start; i <= end; i++) {
                selectedNodes.push(newRowData[i]);
            }
        }
    }

    selectedNodes.sort((row1, row2) => parseInt(row1.rowIndex) - parseInt(row2.rowIndex));
    // Filter updatedRows to include only rows within the selected nodes
    filteredUpdatedRows.push(
        ...updatedRows?.filter((row) => {
            return selectedNodes.some((node) => node.id === row.id);  // Match row id in selected nodes
        })
    );
    setPendingChange({ params, undoDataForPopup, updatedRows: !showPredecessorWarningWhileEditing ? filteredUpdatedRows : updatedRows, index: params.node.rowIndex });
    setPredecessorWarningDialogOpen(true);
    return;
}

// Handle delayed cell value changes in case of asynchronous updates
export const handleDelayedValueChange=(cellValueCallbackArray, params, setPendingChange, setPredecessorWarningDialogOpen, newValue, oldDateValue,gridRef)=> {
    setTimeout(() => {
        if (cellValueCallbackArray.current.calls.length !== 0) {
            const undoDataForPopup = { ...params.data, [params.colDef.field]: oldDateValue };
            openPredecessorWarning(params, setPendingChange, setPredecessorWarningDialogOpen, newValue, oldDateValue,'','',gridRef);
        }
    }, 500);
}

// Helper to check if new and old values differ
export const isDifferentValue=(newValue, oldDateValue, params)=> {
    return newValue !== oldDateValue
    // && params.source !== 'rangeService' && params.source !== 'paste';
}

export const convertRowsToObjectWithIdAsKey = function(rows){
    let rowObj = {}
    rows?.forEach((row) => {
      if(row)  
      rowObj[row.id]= row
    });
    return rowObj;
}

const updateRowsAffectedByPredecessorChange= function(node,colField,newPredecessorValue,idToRemove,predecessorNode){
    let rowsToUpdate=[]
    if(node.data[colField] !== newPredecessorValue){
        node.data[colField] = newPredecessorValue 
        const {loggedInUser} = xTablesStore.getState().gridReducer
        node.data[colField + "_es"] = updateCellValue(node.data,colField + "_es","value",newPredecessorValue,loggedInUser)
        // node.data[colField + "_es"] = updateOrCreateObject(node.data[colField + "_es"], "value", newPredecessorValue);
    }    
    node.data['predecessorNodes'] = removeEleFromStringWithCommaAsDelimiter(node.data['predecessorNodes'], idToRemove); 
    rowsToUpdate = [node];
    let newSuccessorValueForPredecessorRow = removeEleFromStringWithCommaAsDelimiter(predecessorNode.data['successorNodes'], node.id);
    predecessorNode.data['successorNodes'] = newSuccessorValueForPredecessorRow;
    rowsToUpdate.push(predecessorNode);
    return rowsToUpdate
}

export const findColumnUsingParamsOrGridRef = (params, columntype, field) => {
    let columns = params.api.getColumnDefs()
    let resultantColumn;
    if (columntype === 'predecessor') {
        resultantColumn = findColumnByTypeOrField(columns, columntype)
    }
    else if (columntype === 'date' && !field) {
        resultantColumn = findDateRollupColumn(columns)
    }
    else if (columntype === 'duration') {
        resultantColumn = findColumnByTypeOrField(columns, columntype)
    }
    else if(columntype === 'rollup'){
        resultantColumn = findAllRollupColumns(columns)
    }
    else {
        // for endDate column
        resultantColumn = findColumnByTypeOrField(columns, columntype, field)
    }
    return resultantColumn
}

export const parentNodesHaveThisValueAsPredecessor =(parentNodes,childId)=>{
    let hasPredecessor = false
    
        let predecessorNodes = parentNodes[0]?.data?.predecessorNodes
        if(predecessorNodes){
            let predecessorNodesArr=predecessorNodes.split(',')
            hasPredecessor = predecessorNodesArr.includes(childId) ? parentNodes[0] : false
            if(hasPredecessor) return hasPredecessor
        }
    
    return hasPredecessor
}

export function mergeRowsWithPriority(allRowsIncludingRefinedOnes, parentRowsAffectedByRollup, dateRollupColumnsPresent) {
    const { loggedInUser } = xTablesStore.getState().gridReducer;

    const transitionedRowsById = allRowsIncludingRefinedOnes.reduce((acc, node) => {
       if(node) 
       acc[node.id] = node; // Use row ID as key
        return acc;
    }, {});

    const mergedRows = [];
    // Merge rows from `parentRowsAffectedByRollup`, giving priority to parent data
    parentRowsAffectedByRollup.forEach((parentRow) => {
        if(dateRollupColumnsPresent?.block === 'timeseries' && dateRollupColumnsPresent?.type === 'multi dimensional value'){
            let colToEdit = dateRollupColumnsPresent?.field?.endsWith('_es') 
            ? dateRollupColumnsPresent?.field 
            : dateRollupColumnsPresent?.field + '_es';
            let prevData = { 
                ...parentRow, 
                [colToEdit]: { 
                    ...parentRow?.[colToEdit], 
                    value: parentRow?.[colToEdit]?.value
                } 
            };
            const newValue = updateValues(parentRow?.[colToEdit]?.value, dateRollupColumnsPresent.listData, true);
            let myUpdatedValueForRow = updateCellValue(prevData, colToEdit, "value", newValue, loggedInUser);
            parentRow[colToEdit] = myUpdatedValueForRow
            parentRow[dateRollupColumnsPresent.field] = myUpdatedValueForRow.value  
        }
        if (transitionedRowsById[parentRow.id]) {
            // Compare by rollupDate (or other criteria) to decide which to keep
            mergedRows.push(parentRow);
            // Remove the row from transitionedRowsById to avoid duplicate later
            delete transitionedRowsById[parentRow.id];
        } else {
            // If no matching row in transitionedRows, keep the parent row
            mergedRows.push(parentRow);
        }
    });
    //  Add remaining rows from transitionedRowsById (those that weren't merged)
    Object.keys(transitionedRowsById).forEach((id) => {
        mergedRows.push(transitionedRowsById[id]);
    });
    return mergedRows;
}

export const updateStartDateOfUpdatedNode = (rowData, predecessorCol, endDateCol, gridRef, startDateCol, durationCol, startDateColumn) => {

    let rowsToProcess = getNodeListFromIdList(rowData[predecessorCol] === '' ? [] : rowData[predecessorCol]?.split(','), gridRef)
    if (rowsToProcess.length) {
        let endDates = rowsToProcess.map(item => {
            let date = rowData.id === item.node.id ? new Date(rowData[endDateCol + '_es']?.value) : new Date(item.node.data[endDateCol + '_es']?.value);
            return isNaN(date.getTime())
                ? ''
                : new Date(increaseDateByOne(date, `${item.node.id}+${item.duration}`));
        });

        let formattedDate
        if (endDates.includes(null) || endDates.includes('') || endDates.includes(undefined) || !endDates.length) {
            // increasedValue = '';
            formattedDate = '';
        }

        else {
            // Calculate the maximum end date
            const maxDate = new Date(Math.max(...endDates.map(date => new Date(date).getTime())));
            formattedDate = dayjs(maxDate).format('MM/DD/YYYY');
        }

        // Convert increasedValue to Date
        const startDate = formattedDate
        if (startDate != rowData[startDateCol]) {
            rowData[startDateCol] = startDate
            const {loggedInUser} = xTablesStore.getState().gridReducer
            rowData[startDateCol + '_es'] = updateCellValue(rowData,startDateCol + '_es',"value",startDate,loggedInUser)
            // rowData[startDateCol + '_es'] = updateOrCreateObject(rowData[startDateCol + '_es'], 'value', startDate)
            //  rowData = processDuration(rowData, durationCol, startDateCol, endDateCol, startDateColumn);
            let newValueForEndDate = returnEndDateIfStartIsChanged(startDateCol, endDateCol, durationCol, rowData);
            rowData[endDateCol] = newValueForEndDate
            rowData[endDateCol + '_es'] = updateCellValue(rowData,endDateCol + '_es',"value",newValueForEndDate,loggedInUser)
        }
        return rowData
    }
}
// export const editPredecessorAndSucc
export const checkNodesForCircularDependency = (rows, gridRef) => {
    let changedRowsObjWithId = convertRowsToObjectWithIdAsKey(rows)
    let predeccessorColumn = findColumnUsingParamsOrGridRef(gridRef.current, 'predecessor')
    let tweakedRowsAffectedByPredecessorChange = []
    let additionalRowsForUndo = {}
    let allRowsIncludingRefinedOnes = []
    let arrayOfAdditionalUndoRows = []
    if(!predeccessorColumn) return { rowsRefinedWithPredecessorChanges: tweakedRowsAffectedByPredecessorChange, allRowsIncludingRefinedOnes : rows.map((row)=>{if(row.data) return row.data;else return row}), arrayOfAdditionalUndoRows }
    let startDateColumn = predeccessorColumn  ? findColumnUsingParamsOrGridRef(gridRef.current, 'date', predeccessorColumn.linkedColumns.predecessorStartDate) :""
    let { predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate } = startDateColumn.linkedColumns || {};
    rows.forEach((node) => {
        let parentNodes = getAllParentsOfANode(node)
        let allParentNodesMarkedAsVisited = new Set(Array.from(parentNodes).map(row => row.id))
        let doesParentRowHaveThisIdAsPredecessor = parentNodesHaveThisValueAsPredecessor(Array.from(parentNodes), node.id)
        if (doesParentRowHaveThisIdAsPredecessor) {
            if (!changedRowsObjWithId[doesParentRowHaveThisIdAsPredecessor.id])
                additionalRowsForUndo[doesParentRowHaveThisIdAsPredecessor.id] = JSON.parse(JSON.stringify(doesParentRowHaveThisIdAsPredecessor.data))
            let predecessorValueForParent = doesParentRowHaveThisIdAsPredecessor.data.predecessorNodes
            let updatedPredecessorCellArrayForParent = predecessorValueForParent.split(',').filter((ele) => ele !== node.id).join(',')
            updateRowsAffectedByPredecessorChange(doesParentRowHaveThisIdAsPredecessor, predeccessorColumn.field, updatedPredecessorCellArrayForParent, node.id, node).forEach((revisedRow) => {
                changedRowsObjWithId[revisedRow.id] = revisedRow
                tweakedRowsAffectedByPredecessorChange.push(revisedRow.data)
            })
        }
        let parentNodesArray = Array.from(parentNodes)
        let doesParentRowHavePredecessor = parentNodesArray[0]?.data?.predecessorNodes
        if (parentNodesArray[0] && !additionalRowsForUndo[parentNodesArray[0]?.data?.id]) {
            additionalRowsForUndo[parentNodesArray[0]?.data.id] = JSON.parse(JSON.stringify(parentNodesArray[0]?.data));
        }
        if (!changedRowsObjWithId[parentNodesArray[0]?.data?.id] && doesParentRowHavePredecessor) {
            let updatedPredecessorCellArrayForParent = ''
            let predecessorNodes = parentNodesArray[0]?.data.predecessorNodes.split(',')
            predecessorNodes.forEach((predecessorNodeId) => {
                let row = gridRef.current.api.getRowNode(predecessorNodeId)
                additionalRowsForUndo[predecessorNodeId] = JSON.parse(JSON.stringify(row.data))
                updateRowsAffectedByPredecessorChange(parentNodesArray[0], predeccessorColumn.field, updatedPredecessorCellArrayForParent, row.id, row).forEach((revisedRow) => {
                    changedRowsObjWithId[revisedRow.id] = revisedRow
                    tweakedRowsAffectedByPredecessorChange.push(revisedRow.data)
                })
            })
        }
        let predecessorVal = node.data.predecessorNodes
        let updatedPredecessorCellArray = []
        if (predecessorVal) {
            let predecessorNodesArr = predecessorVal.split(',')
            predecessorNodesArr.forEach((predecessorId) => {
                let predecessorNode = changedRowsObjWithId[predecessorId] || gridRef.current.api.getRowNode(predecessorId)
                if (predecessorNode) {
                    if (node.childrenAfterGroup.length) {
                        if (!changedRowsObjWithId[predecessorId])
                            additionalRowsForUndo[predecessorId] = JSON.parse(JSON.stringify(predecessorNode.data))
                        updateRowsAffectedByPredecessorChange(node, predeccessorColumn.field, updatedPredecessorCellArray.join(','), predecessorId, predecessorNode).forEach((revisedRow) => {
                            changedRowsObjWithId[revisedRow.id] = revisedRow
                            tweakedRowsAffectedByPredecessorChange.push(revisedRow.data)
                        })
                        return
                    }
                    let isCircularDependency = checkForCircularDependency(node.id, predecessorId, predecessorNode, gridRef.current, allParentNodesMarkedAsVisited)
                    if (!isCircularDependency) {
                        updatedPredecessorCellArray.push(predecessorId);
                    }
                    else {
                        if (!changedRowsObjWithId[predecessorId])
                            additionalRowsForUndo[predecessorId] = JSON.parse(JSON.stringify(predecessorNode.data))
                        updateRowsAffectedByPredecessorChange(node, predeccessorColumn.field, updatedPredecessorCellArray.join(','), predecessorId, predecessorNode).forEach((revisedRow) => {
                            changedRowsObjWithId[revisedRow.id] = revisedRow
                            tweakedRowsAffectedByPredecessorChange.push(revisedRow.data)
                        })

                    }
                }
                // if(changedRowsObjWithId[predecessorId]) predecessorNode.data = changedRowsObjWithId[predecessorId] 

            })
        }
        let validatedPredecessorValue = updatedPredecessorCellArray.join(',')
        if(validatedPredecessorValue != node.data[predeccessorColumn.field]){
            node.data[predeccessorColumn.field] = validatedPredecessorValue
            const {loggedInUser} = xTablesStore.getState().gridReducer
            node.data[predeccessorColumn.field + "_es"] = updateCellValue(node.data,predeccessorColumn.field + "_es","value",validatedPredecessorValue,loggedInUser)
            // node.data[predeccessorColumn.field + "_es"] = updateOrCreateObject(node.data[predeccessorColumn.field + "_es"], "value", validatedPredecessorValue);    
        }
        
        updateStartDateOfUpdatedNode(node.data, predeccessorColumn.field, endDate, gridRef, startDateColumn.field, duration, startDateColumn)
    })
    Object.keys(changedRowsObjWithId).forEach((changedRow) => {
        if (changedRowsObjWithId[changedRow].data) allRowsIncludingRefinedOnes.push(changedRowsObjWithId[changedRow].data)
        else allRowsIncludingRefinedOnes.push(changedRowsObjWithId[changedRow])

    })
    Object.keys(additionalRowsForUndo).forEach((row) => {
        arrayOfAdditionalUndoRows.push(additionalRowsForUndo[row])
    })
    return { rowsRefinedWithPredecessorChanges: tweakedRowsAffectedByPredecessorChange, allRowsIncludingRefinedOnes, arrayOfAdditionalUndoRows }
}
export const findDateRollupColumn = (columns) => {
    let dateColumnsWithRollup = [];
    for (const column of columns) {
        if (column.type === "date" && (column.rollup === "Max" || column.rollup === "Min")) {
            dateColumnsWithRollup.push(column);
        }
        // Check if the column has children and recursively search them
        if (column.children && column.children.length > 0) {
            const result = findDateRollupColumn(column.children);
            dateColumnsWithRollup = dateColumnsWithRollup.concat(result);
        }
    }
    return dateColumnsWithRollup;
};
export function processParentNodes(
    sortedParentNodes,
    changedRowsObjWithId,
    additionalRowsForUndo,
    dateRollupColumns,
    gridRef,
    predecessorStartDate,
    predecessorEndDate,
    predecessor,
    duration,
    endDate,
    startDate,
    endDateColumn,
    totalColumn,
    timeSeriesColumn
) {
    const {loggedInUser} = xTablesStore.getState().gridReducer
    sortedParentNodes.forEach((parentNode) => {
        let undoRow, parentNodeData, updatedParentNodeData;
        if (!changedRowsObjWithId[parentNode.id]) {
            updatedParentNodeData = gridRef.current.api.getRowNode(parentNode.id) ? gridRef.current.api.getRowNode(parentNode.id) :
              parentNode
            parentNodeData = updatedParentNodeData && updatedParentNodeData.data ? updatedParentNodeData.data : parentNode.data;
            undoRow = JSON.parse(JSON.stringify(parentNodeData));
            additionalRowsForUndo[parentNode.id] = undoRow
        }
        else {
            parentNodeData = changedRowsObjWithId[parentNode.id]
            undoRow = JSON.parse(JSON.stringify(parentNodeData));
        }
        let endDateBeforeProcessing = undoRow[endDateColumn.field]
        processDateRollupsAndSuccessorNodes(
            parentNode,
            parentNodeData,
            dateRollupColumns,
            changedRowsObjWithId,
            gridRef,
            predecessorStartDate,
            predecessorEndDate,
            predecessor,
            duration,
            endDate,
            startDate,
            endDateColumn,
            endDateBeforeProcessing,
            additionalRowsForUndo,
            { totalColumn, timeSeriesColumn },
            sortedParentNodes,
            loggedInUser
        );
        let isParent = true
        const predecessorData = gridRef.current.api.getRowNode(parentNodeData["predecessorNodes"])?.data
        processDuration(parentNodeData, duration, startDate, endDateColumn.field, endDateColumn,"", predecessorData, isParent,loggedInUser)
        if (changedRowsObjWithId[parentNode.id]) {
            delete changedRowsObjWithId[parentNode.id]
            changedRowsObjWithId[parentNode.id] = parentNodeData
        }
        else changedRowsObjWithId[parentNode.id] = parentNodeData
    })
}

export const parentRowsAferRollup = (rows, gridRef, predecessorcolumn, parentNodes, dateRollupColumnsPresent) => {
    let additionalRowsForUndo = {}
    let dateRollupColumns = dateRollupColumnsPresent ? dateRollupColumnsPresent : findColumnUsingParamsOrGridRef(gridRef.current, 'rollup')
    let predeccessorColumn = predecessorcolumn ? predecessorcolumn : findColumnUsingParamsOrGridRef(gridRef.current, 'predecessor')
    let endDateColumn = predeccessorColumn && predeccessorColumn.linkedColumns?.predecessorEndDate? findColumnUsingParamsOrGridRef(gridRef.current, 'date', predeccessorColumn.linkedColumns.predecessorEndDate) :""
    let { predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate } = endDateColumn.linkedColumns || {};
    let changedRowsObjWithId = convertRowsToObjectWithIdAsKey(rows)
    let initialRowObj ={...changedRowsObjWithId}
    let { totalColumn, timeSeriesColumn } = getTotalColumn(gridRef.current)
    // If parentNodes is not provided, derive it from rows
    if (!parentNodes) {
        parentNodes = new Set();
        rows.forEach((row) => {
           if(row) {
            let node = gridRef.current.api.getRowNode(row.id);
            let parents = getAllParentsOfANode(node);
            parents.forEach((parentNode) => parentNodes.add(parentNode));}
        });
    }
    if (parentNodes.size > 0) {
        // Convert parentNodes Set to an array and sort by row index in descending order
        const sortedParentNodes = Array.from(parentNodes).sort((a, b) => b.rowIndex - a.rowIndex);
        processParentNodes(
            sortedParentNodes,
            changedRowsObjWithId,
            additionalRowsForUndo,
            dateRollupColumns,
            gridRef,
            predecessorStartDate,
            predecessorEndDate,
            predecessor,
            duration,
            endDate||predeccessorColumn.linkedColumns?.predecessorEndDate,
            startDate||predeccessorColumn.linkedColumns?.predecessorStartDate,
            endDateColumn,
            totalColumn,
            timeSeriesColumn
        );
        
    const columnDefs = gridRef.current.api.getColumnDefs()
    const hasTimeSeriesInSheet = columnDefs.some(obj => {return obj.hasOwnProperty('block') && (obj.hasOwnProperty('parent') || obj.hasOwnProperty('children'))});
    const {loggedInUser} = xTablesStore.getState().gridReducer

    if(hasTimeSeriesInSheet){
        updateTimeSeriesCellsAfterRollup(columnDefs, sortedParentNodes, loggedInUser)
    }
    }

    let parentRowsAffectedByRollup = []
    Object.keys(changedRowsObjWithId).forEach((changedRow) => {
        if(!initialRowObj[changedRowsObjWithId[changedRow].id]){
            if (changedRowsObjWithId[changedRow].data) parentRowsAffectedByRollup.push(changedRowsObjWithId[changedRow].data)
            else parentRowsAffectedByRollup.push(changedRowsObjWithId[changedRow])
        }

    })
    let additionalParentAndExtraRowsForUndo = []
    Object.keys(additionalRowsForUndo).forEach((row) => {
        additionalParentAndExtraRowsForUndo.push(additionalRowsForUndo[row])
    })
    // Merging logic (to handle priority between merged rows)
    const mergedRowsAfterRollupAndPredecessorChange = mergeRowsWithPriority(rows, parentRowsAffectedByRollup, dateRollupColumnsPresent?.[0])

    return { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange }

}

const updateTimeSeriesCellsAfterRollup = (columnDefs, parentRowsAffectedByRollup, loggedInUser) => {
    const timeSeriesGroups = columnDefs.filter(col => col.marryChildren && isTheGroupTimeseries(col));

    for (const group of timeSeriesGroups) {
        const childCols = getTimeSeriesChildColumns(group);

        for (const childCol of childCols) {
            const colToEdit = getEditableField(childCol.field);

            for (const row of parentRowsAffectedByRollup) {
                if (hasValidTimeSeriesData(row, colToEdit)) {
                    let updatedCellValue = getUpdatedTimeSeriesValue(row, colToEdit, childCol.listData, loggedInUser);
                    const parsed = JSON.parse(updatedCellValue.value);

                    // Remove objects with abbrevation "PT" or "AT"
                    const filtered = parsed.filter(
                        item => item.propAbbrevation === "PT" || item.propAbbrevation === "AT"
                    );
                    updatedCellValue.value= JSON.stringify(filtered) 
                    row[colToEdit] = updatedCellValue;
                    row[childCol.field] = updatedCellValue.value;
                }
            }
        }
    }
};

// 🔹 Helpers to reduce complexity and improve readability
const getTimeSeriesChildColumns = (children) => {
    return getFlatChildrenColumnOfTimeSeries(children.children).filter(child => child.headerName !== 'Total');
};

const getEditableField = (field) => {
    return field?.endsWith('_es') ? field : `${field}_es`;
};

const hasValidTimeSeriesData = (node, field) => {
    try {
        return JSON.parse(node?.data?.[field]?.value || '[]').length > 0;
    } catch {
        return false;
    }
};

const getUpdatedTimeSeriesValue = (row, field, listData, loggedInUser) => {
    const forPrevData = deepCopy(row);
    const prevData = {
        ...forPrevData,
        [field]: {
            ...forPrevData?.[field],
            value: forPrevData?.[field]?.value,
        },
    };
    const newValue = updateValues(row?.[field]?.value, listData, true);
    return updateCellValue(prevData, field, "value", newValue, loggedInUser);
};

export function handleUndoRowUpdates(sourceRows, targetRows=[], uniqueKey) {
    sourceRows?.forEach((row) => {
        if (!targetRows.some((existingRow) => existingRow[uniqueKey] === row[uniqueKey])) {
            targetRows.push(row);
        }
    });
}
// General utility to filter out rows based on a comparison array
export const filterRows = (sourceArray, comparisonArray, shouldExclude = true) => {
    const comparisonIds = new Set(comparisonArray.map((row) => row.id));
    return sourceArray.filter((row) =>
        shouldExclude ? !comparisonIds.has(row.id) : comparisonIds.has(row.id)
    );
};

// Update rows based on a reference array
export const mapUpdatedRows = (rows, referenceRows) => {
    const referenceMap = new Map(referenceRows.map((row) => [row.id, row]));
    return rows.map((row) => referenceMap.get(row.id) || row);
};

export const handleConfirmChange = ({
    pendingChange,
    loggedInUser,
    user,
    gridRef,
    setUndoStack,
    setPredecessorWarningDialogOpen,
    setPendingChange,
    PredecessorRowPresent,
}) => {
    let { data, colDef, oldValue, node, rowIndex } = pendingChange.params || {}
    let updatedRows = pendingChange.updatedRows
    let undoRowAfterChangingDate = pendingChange.undoDataForPopup, changedRows = [], updateSuccessorRows = []
    if (updatedRows && Array.isArray(updatedRows)) {
        updatedRows.forEach(row => {
            let rowsToUpdate
            let undoData = JSON.parse(JSON.stringify(row))
            handleUndoRowUpdates([undoData], undoRowAfterChangingDate, 'id');
            let { duration, endDate, startDate, predecessor, predecessorStartDate, predecessorEndDate } = colDef.linkedColumns || {}
            if (predecessor) {
                row[predecessor] = ''
                row[predecessor + '_es'] = updateCellValue(row, colDef.linkedColumns.predecessor + '_es', "value", '', loggedInUser || user)
                row = processDuration(row, duration, colDef.field, endDate, colDef)
                let successorIds = row['predecessorNodes']?.split(',').filter(Boolean);
                row['predecessorNodes'] = '';
                if (rowsToUpdate) rowsToUpdate.push(row);
                else rowsToUpdate = [row]

                successorIds?.forEach(id => {
                    let successorRowNode = pendingChange.params.api.getRowNode(id);
                    if (successorRowNode && successorRowNode.data) {
                        let successorRowData = successorRowNode.data;
                        let successorundoData = JSON.parse(JSON.stringify(successorRowData))
                        handleUndoRowUpdates([successorundoData], undoRowAfterChangingDate, 'id');
                        successorRowData['successorNodes'] = removeEleFromStringWithCommaAsDelimiter(successorRowData['successorNodes'], row.id)
                        successorRowNode.updateData(successorRowData);
                        updateSuccessorRows.push(successorRowData);
                    }
                })
            }
            changedRows.push(row);
            let result
            if (row.successorNodes && undoData[endDate] !== row[endDate]) {
                result = processSuccessorNodes(row[endDate], row, pendingChange.params.colDef, updatedRows, gridRef, predecessorStartDate, predecessorEndDate, predecessor, duration, endDate, startDate);

            }
            // Merge results into parentRowsToUpdate and rowsForUndo only if they exist
            if (result?.changedSuccessorRows?.length > 0) {
                changedRows = [...changedRows, ...result.changedSuccessorRows]; // Concatenate arrays
            }
            if (result?.undoRows?.length > 0) {
                undoRowAfterChangingDate = [...undoRowAfterChangingDate, ...result.undoRows]; // Concatenate arrays
            }

        })
    }
    changedRows = [...changedRows, ...updateSuccessorRows]
    let { parentRowsAffectedByRollup, additionalParentAndExtraRowsForUndo, mergedRowsAfterRollupAndPredecessorChange } = parentRowsAferRollup(changedRows, gridRef, '', '')
    handleUndoRowUpdates(additionalParentAndExtraRowsForUndo, undoRowAfterChangingDate, 'id');
    pendingChange.params.api.applyTransaction({
        update: mergedRowsAfterRollupAndPredecessorChange,
    });
    setUndoStack([{ type: 'row', action: 'transaction', index: rowIndex, previousRows: undoRowAfterChangingDate, cellRows: mergedRowsAfterRollupAndPredecessorChange, dontSelectCell: true }])

    // Close dialog and confirm the change
    setPredecessorWarningDialogOpen(false);
    setPendingChange(null);
    PredecessorRowPresent.current = false
}
export const getLastLevelChildren=(columns) =>{
    let leafColumns = [];
    columns.forEach(column => {
        if (column.children && Array.isArray(column.children)) {
            // If the column has children, recursively process them
            leafColumns.push(...getLastLevelChildren(column.children));
        } else {
            // If the column does not have children, it is a leaf column
            leafColumns.push(column);
        }
    });
    return leafColumns;
}

export const handleLinkedColumns=(columnDef, columns, updateColumnWithId) =>{
    if (columnDef.linkedColumns) {
        let linkedColumns = columnDef.linkedColumns;
        let allColumnDefs = getLastLevelChildren(columns);
        // Iterate over linked column IDs
        for (let key in linkedColumns) {
            if (linkedColumns[key]) {
                let linkedColumnId = linkedColumns[key]; // e.g., "Column1", "Column2"
                // Find the column definition in allColumnDefs
                let linkedColumnDef = allColumnDefs.find(col => col.field === linkedColumnId);
                // Check if the linked column definition has predecessor-related info
                if (linkedColumnDef?.linkedColumns && !linkedColumnDef.linkedColumns.predecessor) {
                    linkedColumnDef.linkedColumns={...linkedColumnDef.linkedColumns,predecessor:columnDef.field,predecessorEndDate:linkedColumns.predecessorEndDate,
                        predecessorStartDate:linkedColumns.predecessorStartDate}
                    updateColumnWithId(linkedColumnDef)
                }
            }
        }
    }
}

export function updateValue(updatedValue) {
    // Helper function to parse the part of the string
    function parsePart(part) {
      const splitIndex = part.indexOf(": ");
      if (splitIndex === -1) return { label: '', value: part.trim() };
  
      const label = part.slice(0, splitIndex).trim();
      const value = part.slice(splitIndex + 2).trim();
      return { label, value };
    }
  
    // Check if updatedValue contains '=>'
    if (updatedValue?.includes('=>')) {
      const [left, right] = updatedValue.split('=>');
      
      const leftPart = parsePart(left);
      const rightPart = parsePart(right);
  
      // Check if the labels are the same
      const sameLabel = leftPart.label && leftPart.label === rightPart.label;
  
      if (sameLabel) {
        // If the labels are the same, we update the value to reflect the change
        return `${leftPart.label}:${leftPart.value} => ${rightPart.value}`;
      }
    }
  
    // Return the updated value after processing
    return updatedValue;
  }
  